var messages = {
  privacy: {
    title: "vTrack服务使用提示",
    text1: "感谢您的信任，欢迎使用vTrack！",
    text2: "为更好地保护您的权益，请您务必仔细阅读并充分理解vTrack的",
    text3: "《用户协议及隐私政策》",
    end:
      "如您点击“同意”，即表明您已充分阅读、理解并接受上述协议的全部内容。如您“不同意”本协议及其补充协议中的任意条款约定，您可以退出本页面。"
  },
  alert: {
    cancelButtonText: "取消",
    confirmButtonText: "确认",
    cancellationText: "确认注销账号?",
    updateText: "此页面为新模块，请更新最新版本后重试",
    networkError: "网络连接错误",
    unavailable: "此功能需要访问客户端才能使用",
    download: "去下载",
    reload: "重新加载"
  },
  meta: {
    homePage: "首页",
    userPage: "用户",
    userManagement: "用户管理",
    search: "搜索",
    more: "更多",
    upload: "上传",
    uploadSuccess: "上传成功",
    uploadFail: "上传失败",
    loading: "加载中...",
    privacy: "用户协议及隐私政策",
    aboutUs: "关于我们",
    accountDelete: "账号注销",
    kefuList: "智能客服",
    agree: "同意",
    disagree: "不同意",
    noMore: "没有更多了",
    input: "请输入",
    require: "必填项",
    select: "请选择",
    filter: "筛选",
    all: "全部",
    allFilter: "全部筛选",
    dateFilter: "日期筛选",
    view: "查看",
    viewClick: "点击查看",
    reset: "重置",
    confirm: "确定",
    cancel: "取消",
    close: "关闭",
    save: "保存",
    delete: "删除",
    date: "日期",
    beginDate: "开始日期",
    to: "至",
    endDate: "结束日期",
    edit: "编辑",
    editButton: "编辑 / 查看",
    disable: "停用",
    enable: "启用",
    display: "显示",
    hide: "隐藏",
    effective: "生效",
    searchText: "请输入搜索关键词",
    searchType: "搜索条件",
    print: "打印",
    copy: "复制",
    copySuccess: "复制成功",
    operate: "操作",
    operateSuccess: "操作成功",
    detail: "详情",
    basicTitle: "基本信息",
    customerTitle: "客户类型",
    country: "国家",
    city: "城市",
    menu: "操作菜单",
    submit: "提交",
    chagreTitle: "收费项目",
    currency: "货币",
    statistics: "数据统计条件",
    businessType: "业务类型",
    wbType1: "空运",
    wbType2: "海运",
    wbType3: "空派",
    wbType4: "海派",
    wbType5: "快递",
    wbType6: "铁路",
    wbType7: "仓储",
    wbType8: "关务",
    wbType9: "陆运",
    isConsolidation: "是否拼货",
    year: "年",
    month: "月",
    day: "日",
    saveToAlbum: "保存到相册",
    prevPage: "上一页",
    nextPage: "下一页",
    noData: "暂无数据",
    yes: "是",
    no: "否",
    enterprise: "企业",
    personal: "个人",
    systemLanguage: "系统语言",
    autoLanguage: "跟随系统",
    saveSuccess: "保存成功",
    saveError: "保存失败",
    printError: "打印出错",
    notice: "提示",
    deleteConfirm: "确认删除此数据?",
    backHome: "返回首页",
    viewDetail: "查看详情",
    paySuccess: "支付成功",
    payFailure: "支付失败",
    selectTotal: "已选小计",
    showStatistics: "数据统计",
    hideStatistics: "隐藏统计",
    website: "网址",
    newVersion: "发现新版本",
    updateButton: "马上更新",
    laterButton: "明天提醒",
    scanTitle: "扫一扫",
    scanDes: "请扫描二维码或条形码",
    scanButton: "从相册中选择",
    scanError1: "识别失败,请选择正确的二维码/条形码",
    scanError2: "摄像头不可用,请开启相机权限",
    popover1: "扫一扫",
    popover2: "切换语言",
    scanNotice1: "请使用支付宝扫一扫二维码进行支付",
    scanNotice2: "请使用微信扫一扫二维码进行支付",
    add: "新增",
    goToCreate: "去添加",
    noImage: "暂无图片",
  },
  router: {
    home: "vTrack",
    print: "打印页面",
    enterpriseWorkbench: "企业用户工作台",
    workbenchBank: "我的银行账户",
    workbenchSupplier: "供应商信息收集器",
    buildWayBillNo: "生成运单号",
    checkWaybill: "查询/管理运单号",
    checkWaybillDetail: "运单基本信息",
    billsReceivable: "收款账单",
    supplierCostEntry: "供应商成本",
    logisticsStatus: "物流状态管理",
    jobSummary: "货物利润核算",
    orderWayBill: "接单中心",
    orderWayBillDetail: "交接单详情",
    goodsFiles: "货物文件中心",
    goodsFilesDetail: "货物文件明细",
    preAlertDetail: "Pre-Alert详情",
    basicInfo: "客户信息列表",
    basicInfoDetail: "客户基本信息",
    basicInfoAgentList: "海外代理操作列表",
    basicInfoAgentDetail: "海外代理操作信息",
    banckAccountInfo: "银行帐户列表",
    banckAccountInfoDetail: "银行账户信息",
    contactStaff: "联系人员列表",
    contactStaffDetail: "客户方联系人",
    contractManagement: "合同管理列表",
    contractManagementDetail: "合同信息",
    receivingAccountManagement: "收款账户列表",
    receivingAccountManagementDetail: "收款账户信息",
    expenseNameManagement: "账单款项列表",
    expenseNameManagementDetail: "账单款项项目",
    exchangeRateInfo: "币种汇率列表",
    exchangeRateInfoDetail: "新增汇率",
    exchangeRateInfoLog: "币种汇率日志",
    invoiceItemList: "开票项目列表",
    invoiceItemListDetail: "开票名目",
    reportQuerySummary: "待收付查询汇总",
    payrollDetails: "业务请款单",
    payrollList: "运营请款列表",
    payrollRequest: "运营费用请款",
    payrollPayment: "支付运营请款",
    payrollRecords: "请款记录信息",
    reportQuerySummaryDetail: "收款付款明细",
    profitableList: "业务收益汇总",
    profitableListDetail: "利润统计明细",
    finishedCheckBillsSummary: "已核账汇总",
    finishedCheckBillsSummaryDetail: "已核账详情",
    creditedDetails: "已核账明细列表",
    creditedDetailsInfo: "已核账明细详情",
    taxInvoice: "税务发票",
    taxInvoiceDetail: "发票详情",
    financialRequest: "财务请款",
    financialRequestDetail: "请款详情",
    financialAudit: "财务审核",
    financialAuditDetail: "审核详情",
    paymentInvoice: "待确认付款账单",
    cargoStatistics: "货物情况统计",
    lineChartStatistics: "货物定点分布统计",
    expenseStatistics: "费用统计汇总",
    expenseStatisticsDetail: "请款明细列表",
    customerBusinessStatistics: "客户业务统计",
    customerBusinessStatisticsDetail: "客户业务统计详情",
    customerBusinessStatisticsCustomerInfo: "客户收款或付款明细",
    seaFreightDataStatistics: "海运数据统计",
    seaFreightDataStatisticsDetail: "海运数据统计详情",
    warehouseList: "仓库管理",
    warehouseDetail: "仓库信息",
    warehouseSettings: "仓库表单设置",
    warehouseSettingsDetail: "仓库表单内容设置",
    warehouseDelivery: "货物交付管理",
    warehouseDeliveryDetail: "货物交付详情",
    warehouseBill: "入仓工作单",
    warehouseBillDetail: "仓库工作单",
    warehouseProfitAccounting: "仓库利润核算",
    warehouseOperationLogList: "货物操作日志查询",
    advertList: "广告管理",
    advertDetail: "广告详情",
    restrictedList: "受限企业名录",
    restrictedDetail: "受限企业名录详情",
    emailConfig: "邮件配置",
    emailConfigDetail: "邮件配置详情",
    quoteList: "报价中心",
    quoteDetail: "报价单详情",
    quoteCreate: "报价单",
    orderCenterList: "订单处理中心",
    commissionDetail: "委托明细",
    commissionCreate: "货物安排SOP",
    accountingList: "账务中心",
    accountingDetail: "账务明细",
    supplierServiceInformation: "供应商服务信息",
    supplierInformation: "供应商信息",
    answerDetail: "供应商作答树形图",
    overseasGrid: "海外代理",
    overseasDetail: "海外代理报价",
    assetsStatistics: "资产统计",
    assetsStatisticsDetail: "资产详情",
    assetsStatisticsRecord: "使用交接记录",
    employeeInformation: "员工档案信息",
    employeeManagement: "员工信息管理",
    employeeDetail: "员工档案信息详情",
    privacy: "用户协议及隐私政策",
    accountDeletion: "账号注销",
    aboutUs: "关于我们",
    kefuList: "智能客服",
    currencySettings: "货币设置",
    currencySettingsDetail: "货币详情",
    invoiceTitle: "发票抬头",
    consumptionRecord: "消费记录",
    financialAuditProcessSettings: "财务审核设置",
    getWayBillOperationLog: "操作日志",
    expenseCategorySettings: "费用类目设置",
    userList: "用户列表",
    userDetail: "用户信息",
    roleList: "角色列表",
    roleDetail: "分配权限",
    store: "商城",
    payCompletion: "支付详情",
    payQrcode: "扫码支付",
    accountStatements: "账户流水",
    accountStatementsDetail: "客资归账明细信息",
    clientFundDetail: "客资明细",
    clientFundUseList: "客户资金使用明细",
    clientFundExchange: "客户资金换汇记录",
    clientFundDataList: "数据明细列表",
    businessEntry: "客资业务入账",
    businessEntryDetail: "客资业务入账详情",
    financeEntry: "客资财务入账",
    financeEntryDetail: "客资财务入账详情",
    clientFundDetailExchange: "客资换汇",
    clientFundDetailWriteOff: "客户资金销账",
    antiMoneyLaunderingList: "反洗钱名单",
    antiMoneyLaunderingDetail: "反洗钱名单详情",
    antiMoneyLaunderingQuery: "反洗钱记录查询结果",
    temuManifestList: "TEMU订单列表",
    temuManifestDetail: "TEMU订单详情",
    tmsDetail: "TMS订单信息",
    vehiclesList: "车辆管理",
    vehiclesDetail: "车辆详情",
    expressEmployeeList: "快递员工管理",
    expressEmployeeDetail: "快递员工信息",
    cargoWarehousingList: "货物运输管理",
    cargoWarehousingDetail: "运输订单详情",
    cargoWarehousing: "货物运输操作",
    cargoWarehousingException: "订单异常处理",
    cargoWarehousingExceptionRecords: "异常处理记录",
    quotationManagement: "报价管理",
    quotationWarehouse: "仓库信息",
    quotationInformation: "报价信息",
    quotationFreight: "运费信息",
    quotationCustomerDiscount: "客户折扣",
    quotationCustomerDiscountDetail: "客户折扣详情",
    quotationSupplierCreate: "供应商报价详情",
    waitingForStorage: "待入库列表",
    hasBeenStored: "已入库列表",
    hasBeenStoredDetail: "一键生成运单",
    departed: "已启运列表",
    departedDetail: "客户订单集合",
    freightPriceCalculator: "运费计算器",
    cargoWarehousingEditAddress: "编辑收货地址",
    businessEntitySettings: "营业主体设置",
    businessEntitySettingsDetail: "营业主体详情",
    goodsInventory: "采购商品库",
    goodsInventoryCreate: "商品详情",
    goodsInventoryQuotation: "商品报价",
    goodsInventoryQuotationDetail: "报价详情",
    tradeOrder: "贸易订单",
    tradeOrderCreate: "贸易订单生成",
    tradeOrderReconciliation: "贸易订单客资对账",
    procurementQuotationSettings: "报价单位设置",
    procurementQuotationSettingsDetail: "报价单位详情",
    customerHome: "客户首页",
    customerInfo: "企业信息",
    logisticsSection: "物流板块",
    freightInquiry: "运费查询",
    freightInquiryDetail: "运费详情",
    customerQuotationDetail: "报价详情",
    shippingAddress: "地址管理",
    addAddress: "新建收货地址",
    editAddress: "编辑收货地址",
    myWallet: "我的钱包",
    paybillList: "应付账单",
    myWalletRechange: "账户充值",
    orderManagement: "订单管理",
    orderManagementDetail: "订单详情",
    quotationIntegration: "积分规则",
    quotationIntegrationHistory: "积分规则历史记录",
    exportGoodsStatistics: "出口商品统计",
    entrustOrder: "委托单",
    entrustOrderList: "委托单列表",
    entrustOrderCreate: "新建委托单",
    entrustOrderDetail: "委托单详情",
    freightOrder: "货运报价",
    freightOrderList: "货运报价列表",
    freightOrderCreate: "货运报价详情",
    warehouseManagement: "货物仓储",
    warehouseQuery: "货物仓储查询",
    warehouseStatement: "货物流报表",
    financialCounting: "财务对账",
    debtList: "财务对账列表",
    debtDetail: "应付款账单"
  },
  activate: {
    title1: "请完善用户信息",
    title2: "请完善公司信息",
    headImg: "头像",
    username: "用户名",
    email: "联系邮箱",
    save: "保存",
    companyLogoPic: "公司Logo图片",
    businessLicence: "营业执照",
    officialSealPic: "公章图片",
    companyName: "公司名称",
    companyProfileCn: "公司简介 ( 中文 )",
    companyProfileEn: "公司简介 ( 英文 )",
    legalPersonName: "法人名称",
    creditCode: "社会信用代码",
    detailAddress: "详细地址"
  },
  auth: {
    staff: "内部员工",
    customer: "企业客户",
    login: "登录",
    logInSuccess: "登录成功",
    inputPhoneNumber: "请输入手机号",
    inputEmail: "请输入邮箱",
    inputCustomerNumber: "请输入客户编号",
    inputCorrentPhoneNumber: "请输入正确的手机号",
    inputCorrentEmail: "请输入正确的邮箱",
    phoneNumber: "手机号",
    email: "邮箱",
    inputVcode: "请输入验证码",
    inputUsername: "请输入手机号或邮箱",
    inputPassword: "请输入密码",
    inputCompanyCode: "请输入公司代码 ( 可选填 )",
    register: "注册",
    setAccountInfo: "设置账户信息",
    sendAuthCode: "获取验证码",
    next: "下一步",
    backLogin: "返回登录",
    verificationCodeInfo: "已发送验证码",
    username: "用户名",
    inputPaw: "请输入登录密码",
    pawInfo: "密码由6-20位英文字母+数字+符号组成",
    registerSuccess: "注册成功",
    correctError: "请先输入正确的密码",
    confirm: "确认",
    logout: "退出登录",
    customerNumber: "用户编号",
    forgetPassword: "忘记密码",
    resetPassword: "重置密码",
    freeze: "账户已冻结",
    newPassword1: "请输入新密码",
    newPassword2: "请重复输入新密码",
    diffPassword: "两次密码输入不一致",
    activate: "激活账号",
    role: "身份",
    companyName: "公司名",
    companyCode: "公司代码",
    tick: "请勾选",
    rulesAndProtocols: "我已阅读并同意用户协议及隐私政策",
    pickerType1: "登陆账号类型",
    pickerType2: "注册账号类型",
    verifyText: "账号需要验证",
    verifyCode: "验证码",
    get: "获取",
  },
  information: {
    title: "个人信息",
    input: "请输入",
    select: "请选择",
    companyName: "客户企业名称",
    companyNameEn: "企业英文名",
    companyNameSn: "企业简称",
    legalPerson: "企业法人",
    telePhone: "企业固话",
    webSite: "企业网址",
    address: "企业地址",
    certificate: "营业执照",
    personalPassport: "客户护照号",
    personalID: "客户个人身份证号",
    personalIDSn: "客户身份证号",
    customerPhone: "客户手机号",
    customerPassword: "客户密码",
    email: "邮箱",
    country: "国家",
    city: "城市",
    password: "密码",
    submit: "提交",
    save: "保存",
    alert: "请先完善个人信息",
    userInfo: "用户信息",
    avatar: "头像",
    card: "个人名片",
    userName: "用户名",
    phone1: "手机号码1",
    phone2: "手机号码2",
    fixedPhone: "固定电话",
    wechat: "微信号",
    qq: "QQ号",
    whatsapp: "Whatsapp号",
    website: "网址",
    eCard: "电子名片",
    chinese: "中文",
    english: "英文",
    name: "姓名",
    department: "部门",
    position: "职位",
    mailingAddress: "邮寄地址",
    individualResume: "个人简介",
    serviceSectionIntroduction: "业务版块简介",
    projectCase: "项目案例",
    personalSayings: "个人语录",
    filename: "自录入文件",
    customizeName: "自录入命名",
    view: "查看",
    upload: "上传",
    customerNumber: "客户编号",
  },
  enterpriseInfo: {
    title: "企业信息",
    companyInfo: "公司信息",
    companyLogo: "公司Logo图片",
    licence: "营业执照",
    officialSeal: "公章图片",
    companyCode: "公司代码",
    companyName: "公司名称",
    companyProfileCN: "公司简介 ( 中文 )",
    companyProfileEN: "公司简介 ( 英文 )",
    legal: "法人名称",
    creditCode: "社会信用代码",
    detailAddress: "详细地址",
    submit: "提交",
  },
  workbench: {
    username: "我的名字",
    roleName: "系统角色",
    phoneNumber: "联系手机",
    companyName: "企业名称",
    eCard: "电子名片",
    createRequest: "报销请款",
    myBankAccount: "我的银行账户",
    accountName: "银行账户户名",
    accountNo: "银行账户",
    bankName: "开户行",
    qrcode: "电子钱包二维码",
    saveBankInfo: "保存银行信息",
    supplierCollector: "供应商信息收集器",
    shareMessageCN: "分享留言（中文）",
    shareMessageEN: "分享留言（英文）",
    shareQrCode: "问卷二维码",
    saveMessage: "保存留言",
    viewButton: "查看请款单",
    freightPriceCalculator: "运费计算器",
    h5QrCode: "物流驿站",
  },
  employee: {
    title1: "办理入职",
    title2: "个人信息",
    title3: "紧急联系人",
    title4: "学历",
    title5: "语言",
    title6: "培训课程",
    title7: "证书",
    title8: "银行账户",
    title9: "证照归档",
    photo: "个人照片",
    entryDate: "入职日期",
    position: "入职岗位",
    surname: "姓名",
    phoneNumber: "手机号码",
    idCardNumber: "身份证号码",
    marital: "婚姻状况",
    mOption1: "未婚",
    mOption2: "已婚",
    address: "通信地址",
    nationality: "国籍",
    nativePlace: "籍贯",
    gender: "性别",
    male: "男",
    female: "女",
    birthDate: "出生日期",
    contactName: "联系人姓名",
    contactPhone: "联系人手机号码",
    education: "学历",
    school: "毕业院校",
    enrollmentDate: "入学日期",
    graduationDate: "毕业日期",
    languageName: "名称",
    listen: "听",
    say: "说",
    read: "读",
    write: "写",
    lOption1: "一般",
    lOption2: "熟练",
    lOption3: "精通",
    courseName: "课程名称",
    institutions: "培训机构",
    beginDate: "培训开始日期",
    endDate: "培训结束日期",
    certificate: "证书名称",
    cBeginDate: "有效开始日期",
    cEndDate: "有效结束日期",
    payeeName: "收款人姓名",
    bankName: "开户银行",
    bankAccount: "银行账号",
    idCard: "身份证",
    view: "查看",
    upload: "上传",
    graduationBook: "毕业证",
    resignBook: "离职证明",
    resume: "个人简历",
    sourceTitle: "企业分配资源",
    allocatingResource: "分配资源",
    receivingServer: "收件服务器",
    receivePort: "收件端口",
    sendServer: "发件服务器",
    sendPort: "发件端口",
    fixedAssets: "固定资产",
    digitalAssets: "数码资产",
    assetType: "资产类型",
    className: "类别名称",
    goodsName: "产品名称",
    accountNumber: "账户号码",
    welcomeLetter: "欢迎信",
    photo: "图片",
    cardFront: "名片正面",
    cardBack: "名片背面",
    mailSignature: "邮件签名",
    assetNoData: "该资产没有数据",
    classNoData: "该类别没有数据",
  },
  accountDeletion: {
    accountDelete: "账号注销",
    accountDeleteSuccess: "账号注销成功",
    label1: "信息修改问题",
    label2: "其他问题",
    issue1: "无法修改账号名",
    issue2: "手机停用",
    issue3: "修改邮箱",
    issue4: "多余的账号",
    issue99: "填写问题",
    nextStep: "下一步",
    error: "请选择问题",
    termsText: "我已阅读并同意《账号注销重要提醒》"
  },
  aboutUs: {
    currentVersion: "当前版本",
    updateVersion: "版本更新"
  },
  checkWaybill: {
    platformOrder: "平台订单",
    temuOrderNumber: "TEMU 订单号",
    jobNumber: "工作单号",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    shippingDate: "托运日期",
    type: "类型",
    goodState: "货物状态",
    warehouse: "仓库",
    driver: "司机",
    vehicle: "车辆",
    paymentStatus: "收款状态",
    deliveryCustomer: "发货人名称",
    receiveCustomer: "收货人名称",
    receiveCountry: "目的港国家",
    bulkUpdate: "批量更新状态",
    fileList: "文件列表",
    export1: "出口",
    export2: "进口",
    addWbNumber: "添加主运单号",
    repeatBill: "请勿选择已有主运单号行",
    selectSingle: "请选择单个主运单号",
    noWbNumber: "此运单的主运单号还没添加",
    editWbNumber: "修改主运单号",
    viewWbNumber: "查看主运单号",
    deleteWbNumber: "删除运单",
    addSuccess: "添加成功",
    editSuccess: "修改成功",
    searchText: "搜索运单号",
    deliveryPhone: "发货人电话",
    receivePhone: "收货人电话",
    createTime: "托运时间",
    goodsName: "品名",
    weight: "重量",
    pNumber: "件数",
    added: "已添加",
    notAdded: "未添加",
    preAlertTitle: "PreAlert文件",
    mainNoButton: "主运单号文件",
    dialogBillTitle: "提单打印选项（ 可选 ）",
    isLogo: "显示企业LOGO",
    isName: "显示企业英文名",
    isDraft: "添加草稿水印",
    isTelexRelease: "添加电放",
    isOriginal: "添加正本",
    dialogWarehouseTitle: "货物将送货至以下仓库",
    warehouseNameOrNumber: "仓库名称或编号",
    warehouseOwnership: "仓库权属",
    warehouseList: "仓库列表",
    sheet1: "收款账单",
    sheet2: "供应商成本",
    sheet3: "分配仓库",
    sheet4: "查看提单",
    sheet5: "查看面单",
    sheet6: "到货通知 / 工作单",
    preAlertNotice: "勾选同一个主运单号的工作号",
    cargoNotice: "请先勾选运单",
    expressWarehouse: "快递货物入库",
    mawbNumber: "大箱件数",
    dialogSheetTitle: "面单打印选项",
    isPrintVtrackLabel1: "打印渠道商标签",
    isPrintVtrackLabel2: "打印Vtrack标签"
  },
  billsReceivable: {
    project: "项目",
    quantity: "数量",
    unitPrice: "单价",
    total: "总额",
    bankAccount: "银行帐号",
    accountName: "账号名",
    bankName: "银行名",
    address: "地址",
    remark: "备注",
    emailShare: "邮件分享",
    email: "邮箱地址",
    placeholderEmail: "填写多个邮箱以','相隔",
    selectBill: "请选择款项",
    noAccount: "暂无银行账户"
  },
  supplierCostEntry: {
    title: "成本信息明细",
    customName: "客户简称",
    customerNumber: "客户编号",
    quantity: "数量",
    unitPrice: "单价",
    total: "总额",
    referNo: "供应商账单参考号",
    attachments: "添加附件",
    taxInvoice: "税务发票",
    remark: "备注",
    amount: "总金额",
  },
  logisticsStatus: {
    serialNumber: "序号",
    logisticsCn: "物流状态 ( 中文 )",
    logisticsEn: "物流状态 ( 英文 )",
    logisticsSn: "物流状态简称",
    addState: "新增物流状态",
    editState: "修改物流状态",
    stateCn: "物流状态描述/中文",
    stateEn: "物流状态描述/英文",
    sortNumber: "排序序号",
    add: "新增",
  },
  jobSummary: {
    searchText: "请输入主/分运单号",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    kefu: "客服",
    marketing: "市场",
    sales: "销售",
    operation: "操作",
    tradeTitle: "贸易物流",
    deliveryPort: "起运港",
    destinationPort: "目的港",
    costTitle: "成本明细",
    financialAccountNo: "财务记账流水编号",
    customerNumber: "客户编号",
    customName: "客户简称",
    billReferNo: "供应商账单参考号",
    totalPayable: "应付总额",
    totalPayableBalance: "应付余额",
    viewCost: "查看成本",
    deleteCost: "删除成本",
    subTotal: "应收小计",
    rate: "汇率",
    totalAmount: "成本合计",
    sellTitle: "卖价明细",
    invoiceNo: "发票号",
    customerNo: "客户编号",
    totalReceive: "应收总额",
    totalReceiveBalance: "应收余额",
    viewSell: "查看卖价",
    deleteSell: "删除卖价",
    receTotalAmount: "应收合计",
    profitTotalAmount: "利润合计",
    unloadText: "请输入主运单号或分运单号搜索",
    notice: "提示",
    deleteCheck1: "确认删除此成本?",
    deleteCheck2: "确认删除此卖价?",
  },
  orderWayBill: {
    sopNumber: "SOP 单号",
    companyNameSn: "委托企业简称",
    customerNumber: "委托客户编号",
    businessType: "业务类型",
    deliveryCity: "发货地",
    destinationCity: "目的地",
    salesUsername: "跟单销售",
    createTime: "创建日期",
    sales: "销售员",
    pNumber: "件数",
    volume: "体积",
    weight: "重量",
    goodsName: "品名",
    orderState: "订单状态",
    generate: "生成运单号",
  },
  goodsFiles: {
    sopNumber: "SOP 单号",
    sideWbNumber: "分运单号",
    companyNameSn: "委托企业简称",
    customerNumber: "委托客户编号",
    businessType: "业务类型",
    deliveryCity: "发货地",
    destinationCity: "目的地",
    createTime: "创建日期",
    erNumber: "委托参考号",
    date: "日期",
    commission: "委托书",
    contract: "委托合同协议",
    quotation: "报价单",
    supplier: "供应商",
    emailAddress: "邮件地址",
    warehouseNumber: "入仓号",
    supplierPhone: "供应商电话",
    invoice: "发票",
    packingList: "装箱单",
    noticeBill: "入库通知单",
    fileList: "文件列表",
    emailShare: "邮件分享",
    unupload: "暂未上传",
    clickShare: "点击分享",
    goodsFiles: "货物文件",
    saveButton: "保存货物文件",
    viewFile: "查看文件",
    supplierFileList: "供应商文件列表",
    sendInvite: "发送邀请",
    placeholderEmail: "填写多个邮箱以','相隔",
  },
  preAlert: {
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    businessType: "业务类型",
    deliveryCity: "出发地",
    destinationCity: "目的地",
    status: "状态",
    state1: "待确认",
    state2: "已确认",
    flightNumber: "航班号",
    shipmentPortAgent: "发货港代理",
    destinationAgent: "目的港代理",
    dateType: "日期类型",
    receiptDate: "接收日期",
    tab1: "收到的",
    tab2: "发出的",
    totalHawb: "分运单合计",
    transitshipment: "是否转运货物",
    totalNumber: "总件数",
    weight: "重量",
    volume: "体积",
    etd: "预计出发时间",
    atd: "实际出发时间",
    eta: "预计到达时间",
    ata: "实际到达时间",
    remark: "备注",
    log: "操作日志",
    operator: "操作员",
    date: "日期",
    mail: "邮件发送收件人",
    push: "VTRACK推送至",
    companyLogo: "公司Logo图片",
    companyName: "公司名称",
    companyCode: "公司代码",
    companyUser: "企业用户",
    cargoType: "货物类型",
    total: "总计",
    others: "其他",
    remarkPlaceHolder: "货物交接工作备注 ( 打印默认为仅打印MANIFEST 主题部分 )",
    printRemark: "打印备注",
    detailList: "工作单列表",
    button1: "VTRACK 内部推送",
    button2: "发送邮件",
    email: "邮箱地址",
    placeholderEmail: "填写多个邮箱以','相隔",
    preAlertTitle: "PreAlert文件",
    emailLabel: "请选择需要发送的文件",
    file1: "分运单",
    file2: "到货通知",
    workSheet: "生成工作单",
    noticeText: "是否同步生成入仓工作单？"
  },
  basicInfo: {
    companyName: "公司名",
    companyNameEn: "企业英文名",
    companyNameSn: "企业简称",
    companyAddress: "企业中文地址",
    companyCode: "关联公司代码",
    legalPerson: "企业法人",
    telePhone: "企业固话",
    webSite: "企业网址",
    personalID: "客户身份证号",
    personalPassport: "客户护照号",
    customerNumber: "客户编号",
    customerPhone: "客户手机号",
    customerPassword: "客户密码",
    businessLicence: "营业执照",
    area: "地区",
    receivable: "待收余额",
    status: "状态",
    operationInfo: "操作资料",
    addPeople: "添加人",
    referrer: "引荐人",
    addButton: "新增客户",
    refer: "内部引荐人",
    password: "密码",
    createDate: "创建日期",
    createdBy: "创建人名称",
    cityName: "城市名称",
    addAgentButton: "新增代理",
    phoneNumber: "联系电话",
    contact: "联系人",
    email: "邮箱",
    address: "地址",
    notes: "操作注意事项",
    createType: "客户账号类型",
    createType1: "vTrack 账号",
    createType2: "Express 注册账号",
    createType3: "TEMU 快递账号",
    createType4: "Express 收货人账号",
  },
  bankAccount: {
    searchText: "请输入客户编号",
    customerNumber: "客户编号",
    customerName: "客户名称",
    currency: "币别",
    accountName: "收款户名",
    bankNumber: "收款账号",
    status: "状态",
    accountState: "帐户状态",
    addButton: "新增帐户",
    bankName: "开户行",
    bankRegion: "银行地区",
    bankAddress: "银行地址",
    companyAddressEn: "企业英文地址",
    enterpriseId: "企业税号",
    clerk: "录入职员",
    none: "不存在该客户编号"
  },
  contactStaff: {
    customerNumber: "客户编号",
    contact: "联系人",
    customerPhone: "客户手机号",
    addButton: "新增联系人",
    email: "邮箱",
    qqNumber: "QQ号",
    wechat: "微信号",
    telePhoneNumber: "固话",
    liaison: "业务联系员",
  },
  contractManagement: {
    contractNumber: "合同编号",
    contractName: "合同名称",
    customerShort: "客户简称",
    validityDate: "有效期",
    creditLimit: "信用额",
    customerNumber: "客户编号",
    addButton: "新增联系人",
    conclusion: "合同内容简介",
    dIssueBy: "我司执行同事",
    validity: "有效期",
    creditDays: "账期天数",
    attachmentList: "附件列表",
    creditAmount: "账期总额",
  },
  receivingAccountManagement: {
    searchText: "请输入账户名称",
    accountNickName: "账户名称",
    accountName: "账户名",
    bankName: "开户行",
    accountNumber: "账号",
    status: "状态",
    accountState: "帐户状态",
    addButton: "新增帐户",
    address: "企业地址",
    remark: "备注",
    accountCollectionType: "账户收款类型",
    collectionType1: "支付宝",
    collectionType2: "微信",
    collectionType3: "FLYPAY",
    collectionType5: "快递费",
  },
  expenseNameManagement: {
    searchText: "请输入款项项目",
    paymentProject: "款项项目 ( 中文 )",
    paymentProjectEn: "款项项目 ( 英文 )",
    addButton: "新增款项",
  },
  exchangeRateInfo: {
    currency: "币种",
    rate: "汇率",
    time: "时间",
    addButton: "新增汇率",
    searchText: "请输入币种",
    log: "操作日志",
    content: "操作内容",
    username: "操作人",
    createTime: "操作时间",
  },
  invoiceItemList: {
    searchText: "请输入项目名称",
    itemName: "项目名称 ( 中文 )",
    itemNameEn: "项目名称 ( 英文 )",
    addButton: "新增开票名目",
  },
  reportQuerySummary: {
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    financialAccountNo: "财务记账流水编号",
    deliveryPort: "起运港",
    destinationPort: "目的地港口",
    invoiceNo: "账单号",
    createDate: "账单日期",
    total: "账单总额",
    payerName1: "付款客户简称",
    payerName2: "收款客户简称",
    recommend: "推荐人",
    wbNumber: "主/分运单号",
    warehouseWorkNumber: "仓库工作号",
    jobNumber: "工作单号",
    customerNumber: "客户编号",
    companyName: "公司名",
    dataOtion0: "账单为主",
    dataOtion1: "货运单为主",
    dataOtion2: "仓库单为主",
    dataOtion3: "贸易订单为主",
    bill: "生成请款单",
    tab1: "待收款",
    tab2: "待付款",
    tradeTitle: "贸易物流",
    atd: "起运日期",
    amountTitle: "贸易金额",
    outStandingDays: "账期超时天数",
    creditBalance: "可放账款余额",
    balance: "应收余额",
    totalBalance: "应收余额总额",
    rate: "汇率",
    taxInvoice: "税务发票",
    invoiceNumber: "税务发票号",
    invoiceFile: "税务发票文件",
    billDetail: "账单明细",
    viewCost: "查看成本",
    payrollRequest: "请款申请",
    subTotal: "应收小计",
    unreceiveTotal: "待收款合计",
    totalPayableBalance: "应付余额总额",
  },
  payrollDetails: {
    title1: "付款申请",
    title2: "供应商收款信息",
    title3: "户口",
    title4: "付款工作单号",
    title5: "审批流程",
    companyLogo: "公司Logo图片",
    companyName: "公司名称",
    applyDate: "申请日期",
    paymentRecordNumber: "业务请款记录号",
    voucherNumber: "供应商凭证号",
    lastDate: "最迟付款日期",
    remark: "备注",
    supplierCode: "供应商代码",
    supplierName: "供应商名称",
    addAccount: "添加账户",
    addSuccess: "添加成功",
    bankName: "开户行",
    accountNo: "银行账户",
    bankAccount: "收款账户",
    accountDetail: "账户详情",
    accountCurrency: "账户币别",
    bankRegion: "银行地区",
    bankAddress: "银行地址",
    addressEn: "企业英文地址",
    enterpriseId: "企业税号",
    financialAccountNo: "财务记账流水编号",
    workNumber: "工作号",
    payAmount: "付款金额",
    requestCount: "请款次数",
    collection: "收款情况",
    receivedTotal: "收款总额",
    paidTotal: "付款总额",
    profitAmount: "利润总额",
    totalcreditAmount: "已支付总额",
    profitPercent: "利润率",
    paymentCurrency: "请款货币",
    requestAmount: "请款金额",
    position: "职位",
    username: "用户名称",
    approvalState: "批复状态",
    aState1: "待批复",
    aState2: "批复中",
    aState3: "同意",
    aState4: "不同意",
    approvalResult: "审批结果",
    approvalUser: "审批用户名称",
    opinions: "批复意见",
    auditTime: "审核时间",
    approvalOperate: "审批操作",
    agree: "同意",
    disagree: "不同意",
    resubmit: "重新提交",
    saveChange: "保存本次更改",
    tSave: "暂存",
    cancelApply: "取消本次申请",
  },
  payrollRequest: {
    title: "运营费用请款",
    costCate: "费用类目",
    startDate: "开始日期",
    to: "至",
    endDate: "结束日期",
    time: "时间",
    paymentAddress: "用款地址",
    instructions: "用款说明",
    feeAmount: "费用金额",
    voucherNumber: "凭证号",
    requestReceipt: "请款凭证",
    userList: "协同人员",
    isBudget: "是否预算内支出",
    recipient: "受款方式",
    mState1: "现金",
    mState2: "电子钱包",
    mState3: "银行转账",
    qrcode: "电子钱包二维码",
    myBankAccount: "我的银行账号",
    bankInfo: "开户行信息",
    bankAccount: "收款人账号",
    bankName: "收款人名称",
    processList: "审批流程",
    position: "职位",
    username: "用户名称",
    approvalState: "批复状态",
    aState1: "待批复",
    aState2: "批复中",
    aState3: "同意",
    aState4: "不同意",
    approvalResult: "审批结果",
    approvalUser: "审批用户名称",
    opinions: "批复意见",
    auditTime: "审核时间",
    approvalOperate: "审批操作",
    agree: "同意",
    disagree: "不同意",
    resubmit: "重新提交",
    saveChange: "保存本次更改",
    cancelApply: "取消本次申请",
  },
  payrollList: {
    position: "职位",
    type: "请款类型：运营报销",
    paymentRecordNumber: "业务请款记录号",
    applicant: "请款人",
    department: "请款部门",
    submitTime: "提交时间",
    submitCount: "提交次数",
    currency: "货币",
    costAmount: "费用金额",
    menthodState: "收款方式",
    mState1: "现金",
    mState2: "电子钱包",
    mState3: "银行转账",
    approvalState: "批复状态",
    aState1: "审批中",
    aState2: "已完成",
    aState3: "已取消",
    aState4: "驳回",
    aState5: "审批完成",
    paymentState: "支付状态",
    pState1: "待支付",
    pState2: "已支付",
    systemCode: "付款凭证号",
    totalBatch: "审批流层级",
    uploadDate: "凭证上传日期",
    button1: "立即审核",
    button2: "立即支付",
    button3: "编辑运营请款单",
    button4: "请款详情",
    button5: "运营请款",
    paymentTitle: "请上传付款凭证",
    payReceipt: "付款凭证",
  },
  profitableList: {
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    wbNumber: "主/分运单号",
    warehouseWorkNumber: "仓库工作号",
    invoiceNo: "账单号",
    companyName: "公司名",
    userType: "用户类型",
    usType1: "操作",
    usType2: "销售",
    usType3: "客服",
    usType4: "市场",
    jobNumber: "工作单号",
    dataOtion0: "账单为主",
    dataOtion1: "货运单为主",
    dataOtion2: "仓库单为主",
    dataOtion3: "贸易订单为主",
    refer: "内部引荐人",
    tradeTitle: "贸易物流",
    deliveryPort: "起运港",
    destinationPort: "目的地港口",
    atd: "起运日期",
    amountDetail: "金额明细",
    receivedTotal: "收款总额",
    receivedAmount: "收款金额",
    paidTotal: "付款总额",
    payAmount: "付款金额",
    subProfit: "利润小计",
    rate: "汇率",
    received: "收款总金额",
    paid: "付款总金额",
    profits: "利润合计",
  },
  finishedCheckBillsSummary: {
    nuclearAccountNo: "核账记录号",
    creditDate: "核账日期",
    customerName: "客户简称",
    nuclearType: "核账类型",
    wbNumber: "主/分运单号",
    customerNumber: "客户编号",
    companyName: "公司名称",
    nuType1: "收款",
    nuType2: "付款",
    nuType3: "对冲",
    all: "全部",
    dataOtion1: "货运单为主",
    dataOtion2: "仓库单为主",
    bank: "动账银行",
    nuclearTitle: "核账信息",
    receivableAmount: "入账总额",
    creditAmount: "待核销余额",
    details: "查看明细",
    payReceipt: "付款凭证",
    warehouseWorkNumber: "仓库工作号",
    workOrderNumber: "贸易订单工作号"
  },
  taxInvoice: {
    title: "税务发票",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    wbNumber: "主/分运单号",
    invoiceNo: "账单号",
    billDate: "账单日期",
    payerName1: "付款客户简称",
    payerName2: "收款客户简称",
    invoiceAmount: "可开票总额",
    invoiceTotal: "可开票金额",
    invoiceAmountSn: "开票金额",
    invoiceType: "开票类型",
    invoiceType1: "全额开票",
    invoiceType2: "部分开票",
    invoiceNumber: "税务发票号",
    applyDate: "开票日期",
    invoiceDate: "开票申请日期",
    issuedDate: "发票上传日期",
    warehouseWorkNumber: "仓库工作号",
    customerNumber: "客户编号",
    companyName: "公司名",
    recommend: "推荐人",
    all: "全部",
    dataOtion1: "货运单为主",
    dataOtion2: "仓库单为主",
    invoiceItem: "开票项目",
    remark: "备注",
    tab1: "可申请",
    tab2: "已申请",
    tab3: "已开票",
    applyInvoice: "申请全额开票",
    applyHalfInvoice: "申请部分开票",
    refundApplyInvoice: "已申请开票回退",
    refundInvoice: "已开发票回退",
    tradeTitle: "贸易物流",
    deliveryPort: "起运港",
    destinationPort: "目的地港口",
    atd: "起运日期",
    amountTitle: "贸易金额",
    itemName: "开票项目名称",
    applicant: "开票申请人",
    bankAccountInfo: "银行账户信息",
    currency: "币别",
    accountName: "收款户名",
    bankName: "开户行",
    bankRegion: "银行地区",
    bankNumber: "收款账号",
    bankAddress: "银行地址",
    companyAddressEn: "企业英文地址",
    enterpriseId: "企业税号",
    telephone: "企业电话",
    address: "企业地址",
    viewInvoice: "查看税务发票",
    uploadinvoice: "上传税务发票",
    emailAddress: "邮件地址",
    invoiceShare: "发票分享",
    billDetail: "账单明细",
    addInvoice: "添加发票",
    invoiceFile: "税务发票文件",
  },
  financialRequest: {
    paymentRecordNumber: "业务请款记录号",
    approvalState: "审批状态",
    totalBatch: "审批流层级",
    aState1: "审批中",
    aState2: "已完成",
    aState3: "已取消",
    aState4: "驳回",
    aState5: "审批完成",
    menthodState: "收款方式",
    mState1: "现金",
    mState2: "电子钱包",
    mState3: "银行转账",
    paymentState: "支付状态",
    pState1: "待支付",
    pState2: "已支付",
    supplierName: "供应商名称",
    voucherNumber: "供应商凭证号",
    recordNumber: "请款记录号",
    applicant: "请款人",
    department: "请款部门",
    systemCode: "付款凭证号",
    creditRefNo: "核销记录号",
    costCode: "费用凭证号",
    submitDate: "提交日期",
    lastDate: "最迟付款日期",
    uploadDate: "凭证上传日期",
    tab1: "业务款项",
    tab2: "运营报销",
    dTitle1: "供应商和支付信息",
    dTitle2: "费用信息",
    requestReceipt: "请款凭证",
    payAmount: "付款金额",
    payReceipt: "付款凭证",
    submitTime: "提交时间",
    submitCount: "提交次数",
    costAmount: "费用金额",
    costCate: "费用类目",
    button1: "编辑业务请款单",
    button2: "编辑运营请款单",
    button3: "审批业务款项",
    button4: "审批运营报销",
    button5: "查看业务请款单",
    button6: "查看运营请款单",
    payButton: "立即支付",
    txtButton: "请前往电脑端完成支付",
    position: "职位",
    viewButton: "查看请款单"
  },
  paymentInvoice: {
    companyName: "公司名称",
    payInvoiceNo: "付款账单号",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    warehouseWorkNumber: "仓库工作单号",
    createTime: "创建时间",
    invoiceState: "账单状态",
    state1: "全部",
    state2: "待确认",
    state3: "已确认",
    submit: "确认账单",
    invoiceNo: "账单号",
  },
  creditedDetails: {
    invoiceNo: "账单号",
    financialAccountNo: "财务记账流水编号",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    warehouseWorkNumber: "仓库工作号",
    customerName: "客户简称",
    createDate: "账单日期",
    nuclearTitle: "核账信息",
    receivableAmount: "收款账单金额",
    payableAmount: "应付账单金额",
    verifyAmount: "核销金额",
    blance: "余额",
    billDetail: "账单明细",
    viewCost: "查看成本",
    workOrderNumber: "贸易订单工作号"
  },
  cargoStatistics: {
    country: "国家",
    destinationCity: "目的地",
    jobs: "总票数",
    totalValue: "总体积",
    totalWeight: "总重量",
    totalCost: "成本总额",
    totalSell: "总卖价",
    totalProfit: "总利润",
    profitPercent: "利润率",
  },
  lineChartStatistics: {
    cityName: "城市",
    year: "年份",
    currency: "货币",
    month: "月份",
    jobs: "月总票数",
    totalValue: "总体积",
    totalWeight: "总重量",
    airPrice: "空运平均单价",
    price20: "20' 成交平均单价",
    price40: "40' 成交平均单价",
    price40HQ: "40'HQ 成交平均单价",
    priceOther: "Others 成交平均单价",
    selectYear: "选择年份",
    line1: "成本价格线",
    line2: "出售价格线",
    line3: "出售量",
  },
  expenseStatistics: {
    project: "项目",
    year: "年份",
    totalCost: "成本总额",
    itemName: "项目名称",
    parentName: "父类目名称",
    subName: "子类目名称",
    amount: "金额",
    currencySn: "货币缩写",
    parentNameProportion: "父类目支出占比",
    monthTitle: "每月支出金额",
    monthTotal: "每月支出合计",
    selectYear: "选择年份",
    selectMonth: "请选择月份",
    month: "月份",
    monthSn: "月",
    month1: "1月",
    month2: "2月",
    month3: "3月",
    month4: "4月",
    month5: "5月",
    month6: "6月",
    month7: "7月",
    month8: "8月",
    month9: "9月",
    month10: "10月",
    month11: "11月",
    month12: "12月",
    paymentRecordNumber: "业务请款记录号",
    category: "费用子类目",
    applicant: "请款人",
    department: "请款部门",
    submitTime: "提交时间",
    submitCount: "提交次数",
    currency: "货币",
    feeAmount: "费用金额",
    costCode: "费用凭证号",
    menthodState: "收款方式",
    mState1: "现金",
    mState2: "电子钱包",
    mState3: "银行转账",
    approvalState: "审批状态",
    aState1: "审批中",
    aState2: "已完成",
    aState3: "已取消",
    aState4: "驳回",
    aState5: "审批完成",
    paymentState: "支付状态",
    pState1: "待支付",
    pState2: "已支付",
    systemCode: "付款凭证号",
    totalBatch: "审批流层级",
    uploadDate: "凭证上传日期",
    requestReceipt: "请款凭证",
    payReceipt: "付款凭证",
    fileList: "文件列表",
  },
  customerBusinessStatistics: {
    customerNumber: "客户编号",
    companyName: "公司名称",
    totalVotes: "交易总票数",
    tab1: "客户付款",
    tab2: "客户收款",
    airTotalVotes: "空运总票数",
    seaTotalVotes: "海运总票数",
    expressTotalVotes: "快递总票数",
    warehouseTotalVotes: "仓储总票数",
    amountTitle: "贸易金额",
    payAmount: "付款金额",
    receivedAmount: "收款金额",
    amount: "总金额",
    button1: "客户付款明细",
    button2: "客户收款明细",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    invoiceNo: "账单号",
    financialAccountNo: "财务记账流水编号",
    warehouseWorkNumber: "仓库工作号",
    createDate: "账单日期",
    paidTotal: "付款总额",
    receivedTotal: "收款总额",
  },
  seaFreightDataStatistics: {
    tab1: "每月账单统计",
    tab2: "货物港口查询",
    month: "月份",
    wayBillCount: "提单月总票数",
    costBillCount: "账单月总票数",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    deliveryPort: "起运港",
    destinationPort: "目的港",
    deliveryCity: "发货地城市",
    receiveCity: "目的地城市",
    receiveCountry: "目的港国家",
    billName: "账单款项",
    date: "日期",
    cabinet20: "柜型20",
    cabinet40: "柜型40",
    cabinet40HQ: "柜型40HQ",
    cabinetOthers: "柜型Others",
    amountTitle: "贸易金额",
    payAmount: "付款金额",
    cabinetClass: "柜型分类",
    departureDate: "离港日期",
    arrivalDate: "到港日期",
    daysDifference: "运输天数",
  },
  warehouse: {
    warehouseKeeper: "仓库管理员",
    warehouseNameOrNumber: "仓库名称或编号",
    warehouseNumber: "仓库编号",
    warehouseOwnership: "仓库权属",
    warehouseName: "仓库名称",
    warehouseUseType: "仓库使用类型",
    warehouseAddress: "仓库地址",
    warehouseContact1: "仓库联系人1",
    warehouseContact2: "仓库联系人2",
    warehouseStatus: "仓库状态",
    disableOption: "已停用",
    enableOption: "已启用",
    ownerOption1: "自营仓库",
    ownerOption2: "分租托管仓库",
    addButton1: "新增仓库",
    warehouseLogo: "仓库图标",
    warehousePhoto: "仓库图片",
    warehouseTime: "仓库运营时间",
    precaution: "入仓注意事项",
    warehousePhone: "仓库联系电话",
    warehouseEmail: "仓库联系邮件",
    warehouseOption1: "仓库类型(单选)",
    warehouseOption2: "仓库类型(多选)",
    ties: "自营仓库可以填写以下信息",
    isService: "对外承接仓储业务服务",
    contact: "联系人",
    phone: "联系电话",
    photo: "图片",
    startDate: "开始时间",
    endDate: "结束时间",
    recordNumber: "表单设置记录号",
    formName: "表单名称",
    object: "表单内项目",
    editTime: "最后修改时间",
    editor: "最后修改人",
    formState: "表单状态",
    nameOption1: "入仓通知单",
    nameOption2: "货物入仓回单",
    remark: "备注",
    precaution: "入仓注意事项",
    addButton2: "新增表单设置",
    displayContent: "展示内容",
    outboundNumber: "出仓号",
    outBoundTime: "出仓时间",
    warehousingType: "出仓类型",
    warehouseWorkNumber: "仓库工作号",
    warehouseExportNumber: "出仓工作号",
    date: "日期 / 时间",
    warehouseCode: "仓库代码",
    goodsName: "货物品名",
    billEnterprise: "账单企业",
    createTime: "创建时间",
    operation: "操作",
    boxName: "箱名",
    size: "尺寸",
    goodsValue: "货值",
    outBoundState: "出库状态",
    warehouseNumber: "入仓号",
    batch: "批次",
    InStorageTime: "入仓时间",
    warehousingTime: "预计入库时间",
    batchRefNumber: "货物批次参考号",
    criteria: "品名/品牌/型号",
    operateType: "操作类型",
    operation1: "入仓",
    operation2: "出仓",
    operation3: "换仓",
    addButton3: "新建入仓工作单",
    tab1: "待入库",
    tab2: "已入库",
    tab3: "操作日志",
    tab4: "待出库",
    tab5: "已出库",
    pNumber: "件数",
    volume: "体积",
    weight: "重量",
    piecesUnit: "件数单位",
    storageArea: "存放区域",
    storageTime: "仓储时长",
    storageDays: "仓存天数",
    logBtn: "更多明细",
    goodsNameSn: "品名",
    brand: "品牌",
    model: "型号",
    exportNumber: "出库数量",
    inventory: "库存数量",
    long: "长",
    width: "宽",
    height: "高",
    productImage: "产品图片",
    status: "状态",
    bContact: "业务联系人",
    bPhone: "业务联系电话",
    expressTitle: "快递信息",
    expressCompany: "快递公司名称",
    expressNumber: "快递号",
    deliveryTitle: "送货信息",
    emergencyPerson: "紧急联系人",
    emergencyPhone: "紧急联系电话",
    plate: "车牌号",
    cargoTitle: "货物信息",
    esPackage: "预约入仓件数",
    esVolume: "预约入仓体积",
    esWeight: "预约入仓重量",
    adQuantity: "实际交付件数",
    ata: "实际到达时间",
    incomingVolume: "货物到仓体积(立方米)",
    incomingWeight: "货物到仓重量(公斤)",
    warehousingPhoto: "入库图片",
    arrive: "运抵确认",
    outbound: "申请出库",
    viewApply: "查看申请",
    sheet1: "编辑快递信息",
    sheet2: "编辑送货信息",
    sheet3: "编辑仓库工作单",
    sheet4: "收款账单",
    sheet5: "费用成本",
    sheet6: "仓库工作单详情",
    sheet7: "出库工作单详情",
    entrustEnterprise: "入仓委托企业",
    customerNumber: "客户编号",
    productsName: "货物名称",
    warehouseSn: "仓库",
    driverInfo: "入仓司机资料",
    driverName: "联系负责人",
    driverPhone: "联系电话",
    driverPlate: "送货车牌号",
    addProduct: "添加货物",
    addProductFirst: "请先添加货物",
    cargoName: "货物",
    productsNameSn: "产品名称",
    unitPrice: "单价",
    quantity: "总数量",
    surplus: "剩余数量",
    packingDetail: "货物装箱",
    pushButton: "装箱",
    caseNumberSn: "箱号",
    parentBox: "父级箱号",
    caseNumber: "箱号 / 托盘号",
    packingQty: "装箱数量",
    goodsDetail: "货物详情",
    goodsValueTotal: "货值总价",
    noImage: "暂无图片",
    productList: "产品列表",
    dialog1: "请选择产品",
    dialog2: "此货物已装箱",
    dialog3: "请输入装箱数量",
    dialog4: "装箱剩余数量不足",
    dialog5: "装箱数量大于剩余数量",
    dialog6: "产品添加完成",
    dialog7: "不能选择相同的箱子",
    dialog8: "编辑产品名称",
    dialog9: "编辑产品图片",
    warehouseInfo: "仓库信息",
    warehouseWorkOrderNumber: "仓库工作单号",
    warehouseStorageName: "存放仓库名称",
    entrustEnterpriseOB: "出仓委托企业",
    enterprise: "企业名称",
    warehouseData: "入库资料",
    meter: "立方米",
    kilo: "公斤",
    existingData: "现存资料",
    warehouseDetail: "仓储明细",
    warehouseType: "仓储类型",
    option1: "货物转仓",
    option2: "货物出仓",
    onePiece: "一件代发",
    selectCargo: "选择出仓货物",
    goodsExistDetail: "货物现存详情",
    selectAll: "全选",
    parentBoxName: "父级箱名称",
    dayOfStorage: "存放天数",
    updateName: "更新产品名称",
    updateImage: "更新产品图片",
    total: "合计",
    productTotal: "产品总计",
    outboundTotal: "出库总计",
    boxTotal: "箱数总计",
    pickupPerson: "接货司机资料",
    others: "其他",
    printBtn: "打印出仓签收单",
    printAgainBtn: "再次打印出仓签收单",
    inputNumberSearch: "请输入仓库工作号",
    days: "天",
    costTitle: "成本明细",
    sellTitle: "卖价明细",
    financialAccountNo: "财务记账流水编号",
    customerName: "客户简称",
    billReferNo: "供应商账单参考号",
    totalPayable: "应付总额",
    viewCost: "查看成本",
    deleteCost: "删除成本",
    subTotal: "应收小计",
    rate: "汇率",
    totalAmount: "成本合计",
    invoiceNo: "发票号",
    totalReceive: "应收总额",
    viewSell: "查看卖价",
    deleteSell: "删除卖价",
    receTotalAmount: "应收合计",
    profitTotalAmount: "利润合计",
    unloadText: "请输入仓库工作号搜索",
    notice: "提示",
    deleteCheck1: "确认删除此成本?",
    deleteCheck2: "确认删除此卖价?",
    warehousingInfo: "入库信息",
    productModel: "产品型号",
    productBrand: "产品品牌",
    numberBoxes: "箱数",
    totalPackingQuantity: "装箱总数量",
    totalGoodValue: "总货值",
    entrustingParty: "委托方",
    stockQueryType: "库存查询类型",
    stockQueryType1: "全部数据",
    stockQueryType2: "仅显示有库存的数据",
    queryTotal1: "货物品类总数",
    queryTotal2: "货物总箱数",
    queryTotal3: "货物总货值",
    statementTotal1: "入仓总箱数",
    statementTotal2: "入仓总数量",
    statementTotal3: "入仓总货值",
    statementTotal4: "出仓总箱数",
    statementTotal5: "出仓总数量",
    statementTotal6: "出仓总货值",
    sort: "排序",
    emailPush: "邮件推送",
    emailPushTest: "推送测试",
    emailSetting: "邮箱配置",
    emailLabel: "推送邮箱",
    emailError: "请先设置邮件配置",
    sendSetting: "发送周期",
    sendDate: "发送日期",
    sendTime: "发送时间",
    configState: "配置状态",
    daily: "每天",
    fixedDate: "固定日期",
    weekly: "每周",
    monthly: "每月",
    week0: "星期天",
    week1: "星期一",
    week2: "星期二",
    week3: "星期三",
    week4: "星期四",
    week5: "星期五",
    week6: "星期六",
    emailLanguage: "邮件显示语言",
    emailLanguage1: "中文",
    emailLanguage2: "英文"
  },
  marketRisk: {
    advertTitle: "广告标题",
    advertTypeStr: "广告类型描述",
    advertType: "广告类型",
    advertContent: "广告内容（中文）",
    advertContentEn: "广告内容（英文）",
    showType: "展示类型",
    moduleType: "模板类型",
    moduleStr: "模板",
    lineUrl: "外部链接的Url",
    isShow: "是否显示",
    newAdvert: "新建广告",
    all: "全部",
    graphic: "图文广告",
    externalLinks: "外部链接",
    notDisplay: "不展示",
    display: "展示",
    pcStation: "PC端",
    wxStation: "小程序端",
    linkParam: "链接参数",
    sort: "排序",
    imgUrl: "预览图",
    customerNumber: "客户编号",
    customerName: "客户名称",
    country: "国家",
    city: "城市",
    lPerson: "法人",
    sales: "业务员",
    phone: "手机号",
    setBlock: "启用受限",
    closeBlock: "关闭受限",
    newRestrict: "新建名录",
    entrustEnterprise: "入仓委托企业",
    companyNameEn: "企业英文名",
    companyNameSn: "企业简称",
    legalPerson: "企业法人",
    legalPersonPhone: "法人手机",
    businessNo: "营业执照编号",
    salesName: "业务员名称",
    salesPhone: "业务员手机",
    addPeople: "添加人",
    serviceEmail: "客服邮箱",
    contactPhone: "联系电话",
    wechat: "微信号",
    createPush: "新建邮件推送",
    fileQrcode: "文件同事二维码",
    accountQrcode: "公众号二维码",
    isEnabled: "是否启用",
  },
  salesManagement: {
    qrNumber: "询价参考号",
    qNumber: "报价单号",
    quoteDate: "报价日期",
    quotePeople: "报价负责人",
    companyName: "公司名称",
    businessType: "业务类型",
    delivery: "起运地",
    destination: "目的地",
    supplierName: "供应商名称",
    nickName: "发单人手机号",
    sales: "负责销售",
    createTime: "询价申请时间",
    state: "状态",
    option1: "已报价",
    option2: "待报价",
    addQuote: "新建报价单",
    tab1: "待报价",
    tab2: "报价单",
    title1: "客户询盘详情",
    title2: "货物详情",
    title3: "报价单详情",
    title4: "新建报价单",
    enterprise: "企业名称",
    initiationPhone: "发起人联系电话",
    initiationTime: "发起时间",
    goodsName: "货物名称",
    tradeTerms: "贸易条款",
    pNumber: "件数",
    volume: "体积",
    weight: "重量",
    piecesUnit: "件数单位",
    volumeUnit: "体积单位",
    weightUnit: "重量单位",
    brand: "品牌",
    liquid: "液体",
    powder: "粉末",
    magnetic: "磁性",
    export1: "代理出口",
    export2: "出口退税",
    export3: "进口",
    commission: "委托报关",
    tdService: "提货服务",
    takeDeliveryCity: "提货国家城市",
    takeDeliveryPerson: "提货联系人",
    takeDeliveryContactPhone: "提货联系电话",
    takeDeliveryAddress: "提货地址",
    tdLocation: "提货地点",
    addQuotation: "添加报价",
    qValidity: "报价有效期",
    qDate: "报价单日期",
    customerNumber: "企业编号",
    deliveryPort: "起运港",
    destinationPort: "目的港",
    exportType: "报价单类型",
    pricing: "定价",
    unit: "单位",
    total: "总计",
    carrier: "航空公司",
    transitTime: "运输时长",
    remark: "备注",
    polTitle: "起运港费用",
    freightTitle: "运输费用",
    podTitle: "目的港费用",
    serviceTitle: "附加服务费用",
    inputOrderNumber: "请输入委托单号",
    orderNumber: "委托单号",
    erNumber: "委托参考号",
    orderPcState: "订单状态",
    createDate: "创建时间",
    entrustDetail: "委托明细",
    customerInfo: "客户资料",
    addSop: "新增 SOP",
    viewSop: "查看 SOP",
    orderState: "委托单后台状态",
    state1: "待建SOP",
    state2: "待操作",
    state3: "待出运",
    state4: "待出账单",
    state5: "待收款",
    state6: "完成",
    createButton: "新建委托单",
    title5: "货运委托单",
    title6: "物流信息",
    sales: "负责销售员",
    entrustDay: "委托日期",
    shipper: "发货人",
    consignee: "收货人",
    notify: "通知人",
    paymentTerms: "付款条款",
    goodsData: "货物数据",
    sopNumber: "SOP号",
    costTitle: "成本明细",
    sellTitle: "卖价明细",
    notes: "操作交接明细",
    entrustEnterprise: "入仓委托企业",
    later: "稍后补充",
    contactPhone: "联系电话",
    address: "地址",
    email: "邮箱地址",
    same: "通知人与收件人信息一致",
    deliveryCity: "发货地",
    destinationCity: "目的地",
    entrustType: "委托单类型",
    costPay: "费用付款",
    rule: "业务规则及合同",
    warehouseWorkNumber: "仓库工作号",
    wbNumber: "主/分运单号",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    customerId: "客户编号",
    atd: "起运日期",
    invoiceNo: "账单号",
    createDate: "账单日期",
    billTotal: "账单总额",
    recommend: "推荐人",
    nuType1: "收款",
    nuType2: "付款",
    nuType3: "对冲",
    accoutingTab1: "待收款",
    accoutingTab2: "已收款",
    accoutingTab3: "业务收益汇总",
    kefu: "客服",
    marketing: "市场",
    sales: "销售",
    operation: "操作",
    tradeTitle: "贸易物流",
    amountTitle: "贸易金额",
    receivedAmount: "收款金额",
    receivedTotal: "收款总额",
    payAmount: "付款金额",
    paidTotal: "付款总额",
    subProfit: "利润小计",
    balance: "应收余额",
    totalBalance: "应收余额总额",
    rate: "汇率",
    nuclearTitle: "核账信息",
    nuclearAccountNo: "核账记录号",
    creditDate: "核账日期",
    shortName: "客户简称",
    nuclearType: "核账类型",
    bank: "动账银行",
    receivableAmount: "入账总额",
    payerName: "付款客户简称",
    outStandingDays: "账期超时天数",
    creditBalance: "可放账款余额",
    taxInvoice: "税务发票",
    invoiceNumber: "税务发票号",
    invoiceFile: "税务发票文件",
    details: "查看明细",
    billDetail: "账单明细",
    transportType: "运输方式",
    chargeableWeight: "收费重量",
    warehouseState1: "待入仓",
    warehouseState2: "已入仓",
    warehouseState3: "已完成",
    createEntrustOrder: "新建委托单",
    qState: "报价状态",
    quoteTime: "报价时间",
    createFreightOrder: "新建报价单",
    goodsNameEn: "英文品名",
    billInformation: "提单资料",
    shipperAddress: "发货人地址",
    shipperPhone: "发货人联系电话",
    shipperEmail: "发货人邮箱地址",
    consigneeAddress: "收货人地址",
    consigneePhone: "收货人联系电话",
    consigneeEmail: "收货人邮箱地址",
    notifyAddress: "通知人地址",
    notifyPhone: "通知人联系电话",
    notifyEmail: "通知人邮箱地址",
    supplier: "供应商",
    warehouseNumber: "入仓号",
    supplierList: "供应商列表",
    invoice: "发票",
    packingList: "装箱单",
    goodState: "货物状态",
    emailShare: "邮件分享",
    clickShare: "点击分享",
    sendInvite: "发送邀请",
    placeholderEmail: "填写多个邮箱以','相隔",
    workInquiryNumber: "工作查询号",
    bookingNumber: "提单号",
    subTotal: "应收小计",
    unreceiveTotal: "待收款合计",
    orderCustomer: "建单客户",
  },
  supplier: {
    addTitle: "新增海外代理服务报价",
    editTitle: "编辑海外代理服务报价",
    quotationCollection: "报价集合",
    minimumUnit: "最低消费收费单位",
    minimum: "最低消费",
    denistyRatio: "体积重比率",
    sectionCharge: "收费段",
    awWay: "接入途径",
    collection: "收款项目",
    createQuote: "新建报价",
    shipperCompany: "托运人公司",
    dealCount: "近12个月成交次数",
    costRecord: "成本记录编号",
    companySn: "企业简称",
    code: "报价港口",
    bcType: "业务类别",
    unitPrice: "单价",
    unitPriceCharge: "单价收费单位",
    address: "地址",
    section: "分段",
    contact: "联系人",
    contactPhone: "联系电话",
    notes: "操作注意事项",
    email: "邮件",
    area: "地区",
    country: "国家",
    city: "城市",
    companyName: "公司名称",
    contactName: "联系人名称",
    phoneNumber: "联系方式",
    wechat: "微信号",
    referrer: "引荐人",
    lastDate: "信息最后更新日",
    cooperate: "合作次数",
    serviceArea: "服务区域",
    serviceCate: "服务类别",
    serviceCountry: "服务国家",
    operatingProducts: "经营产品",
    businessClass: "业务分类",
    serviceContent: "服务内容",
    serviceDetail: "服务内容明细",
    regulatory: "监管类别",
    warehouseCate: "仓库类别",
    danger: "危险品存放登记",
    vehicleNum: "车辆数量",
    vehicleCate: "车辆类别",
    vehicleType: "车辆类型",
    carrier: "承运人",
    mainBusiness: "主营业务",
    exportCate: "进出口类目",
    wbType1: "空运空派",
    wbType2: "海运海派",
    wbType3: "快递服务",
    wbType4: "铁路运输",
    export1: "出口",
    export2: "进口",
    business1: "空运头程",
    business2: "包机服务",
    business3: "海运订舱",
    business4: "特种柜",
    business5: "服务代理",
    area1: "市内",
    area2: "省内",
    area3: "国内",
    area4: "澳门",
    area5: "香港",
    car1: "普通车",
    car2: "监管车",
    car3: "跨境车",
    car4: "冷藏车",
    weight1: "3吨",
    weight2: "5吨",
    weight3: "8吨",
    weight4: "10吨",
    weight5: "12吨",
    weight6: "18吨",
    weight7: "拖车",
    weight8: "吊臂车",
    weight9: "平板车",
    serveWarehouse1: "国内仓储",
    serveWarehouse2: "港澳台仓储",
    serveWarehouse3: "国外仓储",
    superviseWarehouse1: "普通仓",
    superviseWarehouse2: "保税仓",
    superviseWarehouse3: "海关监管仓",
    superviseWarehouse4: "FBA海外仓",
    typeWarehouse1: "室外露天平地",
    typeWarehouse2: "室内仓库",
    typeWarehouse3: "集装箱堆场",
    typeWarehouse4: "光地储存",
    typeWarehouse5: "普通室内仓",
    typeWarehouse6: "电商分拣仓库",
    typeWarehouse7: "恒温仓储",
    typeWarehouse8: "冷冻仓储",
    typeWarehouse9: "危险品仓",
    service1: "关务申报",
    service2: "贸易代理",
    service3: "包装及物料",
    service4: "货运保险",
    service5: "口岸服务",
    service6: "检验勘察",
    service7: "货运法务",
    tab1: "供应商运输服务",
    tab2: "供应商汽运服务",
    tab3: "供应商仓储服务",
    tab4: "供应商行业增值配套服务",
  },
  enterpriseLogistics: {
    searchText1: "请输入产品 / 品牌 / 型号",
    searchText2: "请输入姓名 / 手机号",
    assetClassName: "资产类别名称",
    accountName: "账号名称",
    accountNumber: "账户号码",
    setMealConfig: "套餐配置",
    loginPassword: "登陆密码",
    accountLocation: "账号属地",
    assetState: "资产状态",
    aState1: "在库",
    aState2: "外借",
    aState3: "归还",
    goodsName: "产品名称",
    goodsModel: "产品型号",
    goodsBrand: "产品品牌",
    goodsConfig: "产品配置",
    goodsSize: "产品尺寸",
    goodsArea: "产品面积",
    goodsAddress: "产品地址",
    purchaseDate: "购买日期",
    openingDate: "开户日期",
    handoverDate: "交接日期",
    purchaseAmount: "购买金额",
    handoverRecord: "交接记录",
    assetType: "资产类型",
    addClass: "添加类别",
    className: "类别名称",
    fixedAssets: "固定资产",
    digitalAssets: "数码资产",
    createAssets: "新建资产",
    editAssets: "编辑资产",
    addAssets: "添加资产",
    fileList: "资产文件列表",
    class: "类别",
    photo: "图片",
    incharge: "交接人",
    customerNumber: "用户编号",
    surname: "姓名",
    position: "入职岗位",
    gender: "性别",
    male: "男",
    female: "女",
    phoneNumber: "手机号码",
    nativePlace: "籍贯",
    education: "最高学历",
    entryState: "入职状态",
    employment: "在职",
    dimission: "离职",
    entryDate: "入职日期",
    resignationDate: "离职日期",
    employeeResign: "员工离职",
    listOrderBy: "列表排序",
    orderBy1: "按信息录入时间排序",
    orderBy2: "按入职日期排序",
    orderBy3: "按离职日期排序",
  },
  currencySettings: {
    searchText: "货币或货币缩写",
    addButton: "新增货币",
    currency: "货币",
    currencySn: "货币缩写",
    currencySymbol: "货币符号",
    useState: "使用状态",
    settlement: "是否设置结算货币",
    setCurrency: "设置结算货币",
  },
  invoiceTitle: {
    titleType: "抬头类型",
    unit: "单位",
    taxNumber: "公司税号",
    address: "公司地址",
    phone: "公司电话",
    bankName: "开户银行名称",
    bankAccount: "开户银行账号",
    alert:
      "公司抬头和公司税号添加后不允许修改，如果修改请提交申请或者直接联系客服修改",
  },
  consumptionRecord: {
    allOrderNumber: "主订单号",
    cOrderNumber: "分订单号",
    orderType: "订单类型",
    orderState: "订单状态",
    paymentState: "支付类型",
    totalAmount: "订单总金额",
    payAmount: "实付金额",
    orderTime: "下单时间",
    actualDate: "订单支付时间",
    methods: "支付方式",
    typeOption1: "功能开通",
    typeOption2: "功能扩展",
    typeOption3: "续费",
    stateOption1: "待支付",
    stateOption2: "已支付",
    stateOption3: "已失效",
    paymentOption1: "微信",
    paymentOption2: "支付宝",
    paymentOption3: "公账",
    paymentTitle: "请转账到以下账户",
    bankName: "开户银行",
    bankAccount: "银行账号",
    hotline: "客服热线",
    gotoPay: "去支付",
  },
  financialAuditProcessSettings: {
    tab1: "业务成本审核",
    tab2: "运营费用审核",
    auditor: "审核员",
    level: "等级",
    job: "职位名称",
    charge: "可执行人员",
    cashier: "出纳员",
  },
  getWayBillOperationLog: {
    searchText1: "操作号",
    searchText2: "款项查询号 / 流水登记号",
    tab1: "运单操作日志",
    tab2: "入账操作日志",
    log: "操作日志",
    content: "操作内容",
    inquiryNumber: "款项查询号",
    srNumber: "流水登记号",
    date: "操作日期",
    username: "操作人",
  },
  expenseCategorySettings: {
    project: "项目",
    name: "类目名称",
    category: "费用子类目",
    parent: "父级类目",
    addTitle: "添加费用类目",
    editTitle: "编辑费用类目",
    addButton: "新增费用类目"
  },
  userList: {
    searchText: "用户名 / 手机号",
    avatar: "头像",
    username: "用户名",
    createTime: "注册时间",
    contactNumber: "联系号码",
    phone: "手机号",
    email: "邮箱",
    parentUserName: "部门经理",
    password: "密码",
    userState: "用户状态",
    roleName: "用户角色",
    parentName: "上级主管",
    freeze: "冻结",
    thaw: "解冻",
    status: "状态",
    option1: "正常",
    option2: "已冻结",
    addUser: "添加用户",
    verifyCode: "验证码",
    get: "获取",
    assignRole: "分配角色",
    role: "角色名称",
    deleteText: "确认删除此用户?",
    selectRole: "请选择角色",
    selectUser: "请选择用户",
  },
  roleList: {
    role: "角色名称",
    editRole: "编辑角色",
    addRole: "新建角色",
    isSuper: "是否设为主管角色",
    dialogText: "是否删除该角色?",
    setRight: "分配权限",
    searchText: "搜索角色名称",
    roleClass: "角色分级",
    manager: "主管",
    distributor: "分销商"
  },
  store: {
    companyName: "公司名称",
    companyAccount: "公司帐号",
    remind: "剩余账号",
    vpDate: "套餐到期日期",
    unpaidText: "您有一张待支付订单",
    onPay: "去支付",
    back: "返回",
    isBuy: "已开通",
    accountNumber(val) {
      return "账号数量 (" + val + "¥/个)";
    },
    accountLanguage(val) {
      return "系统多语言功能 (" + val + "¥)";
    },
    accountWxMini(val) {
      return "微信小程序 (" + val + "¥)";
    },
    validityDate: "有效期",
    cutoff: "购买套餐有效期截止至",
    menusLabel: "套餐选择(多选)",
    coupon: "优惠券",
    payCurrency: "支付货币",
    methods: "支付方式",
    totalAmount: "总费用",
    discountAmount: "优惠金额",
    payAmount: "应付金额",
    agreementText: "我已阅读并同意Vtrack服务协议",
    orderButton: "立即下单",
    stepOption1: "功能开通",
    stepOption2: "功能扩展",
    stepOption3: "套餐续费",
    ruleIsAgree: "请勾选服务协议",
    paymentOption1: "微信",
    paymentOption2: "支付宝",
    paymentOption3: "线下支付",
    expire: "已到期",
    year: "年",
    guideText: "请点击需要操作的业务",
  },
  clientFund: {
    serialRegistrationNumber: "流水登记号",
    creditRefNo: "核销记录号",
    exchangeNo: "换汇号",
    fundClass: "款项归类",
    paymentType1: "业务款",
    paymentType2: "运营费用款",
    accountName: "入账账户名称",
    remitterName: "汇款人名称",
    remittanceLocation: "汇出地",
    remittanceAmount: "汇出金额",
    remittanceCurrency: "汇出币别",
    bankCharges: "银行手续费",
    bankChargesCurrency: "银行手续费币别",
    customerNumber: "客户编号",
    customerName: "客户名称",
    companyName: "公司名称",
    receivedAmount: "到账金额",
    receivedCurrency: "到账币别",
    transferDate: "归账日期",
    bankAccount: "收款账户",
    minAmount: "最小金额",
    maxAmount: "最大金额",
    inquiryNumber: "款项查询号",
    paymentTradeNumber: "支付交易号",
    fillInDate: "填写日期",
    receiveDate: "到账日期",
    entryType: "入账类型",
    type1: "业务",
    type2: "财务",
    entryState: "入账状态",
    entryState1: "待归账",
    entryState2: "已归账",
    entryState3: "已删除",
    remark: "备注",
    agent: "经办人",
    entryFile: "入账文件",
    dic1: "待收款金额",
    dic2: "待收款总额",
    dic3: "待核销余额",
    dic4: "待核销余额总额",
    clientFundUse: "客户资金使用明细",
    clientFundData: "待收款总额明细",
    sort: "排序",
    fundType: "资金类型",
    fdType1: "流入",
    fdType2: "流出",
    fdType3: "换汇流入",
    fdType4: "换汇流出",
    fdType5: "销账",
    operateDate: "操作日期",
    bookCurrency: "记账货币",
    bookAmount: "记账金额",
    originBalance: "原账户余额",
    bookBalance: "记账后账户余额",
    username: "操作用户",
    writeOff1: "销账货币",
    writeOff2: "销账金额",
    writeOff3: "销账备注",
    useButton1: "客资归账明细",
    useButton2: "查看已核明细",
    useButton3: "资金换汇记录",
    exchangeCurrency: "换汇币别",
    exchangeAmount: "换汇金额",
    exchangeBeforeBalance: "换汇前账户余额",
    exchangeAfterBalance: "换汇后账户余额",
    convertBeforeBalance: "兑换前账户余额",
    convertAfterBalance: "兑换后账户余额",
    rate: "换汇汇率",
    fromCurrecny: "换汇货币",
    toCurrency: "兑换货币",
    toAmount: "兑换金额",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    invoiceNo: "账单号",
    warehouseWorkNumber: "仓库工作号",
    createDate: "账单日期",
    beforeBlance: "可用余额",
    afterBlance: "兑换后余额为",
    frozenBalance: "已冻结金额",
    amountStatistics: "金额统计",
    dateStatistics: "日期统计",
    createTime: "创建日期",
    customer: "入账客户",
    fileList: "文件列表",
    file: "文件",
    businessTitle1: "查看客资业务入账",
    businessTitle2: "编辑客资业务入账",
    businessTitle3: "添加客资业务入账",
    businessAddButton: "新建客资业务入账",
    fundsTransferCustomerNumber: "资金归入客户编号",
    fundsTransferCustomerName: "资金归入客户简称",
    transferUserName: "归属操作员",
    financeTitle1: "查看客资财务入账",
    financeTitle2: "编辑客资财务入账",
    financeTitle3: "添加客资财务入账",
    financeAddButton: "新建客资财务入账",
    transfer1: "客资归账",
    transfer2: "确认归账",
    transfer3: "取消归账",
    transferNotice: "请选择同一个汇款人进行归账",
    customerNotice: "财务确认入账客户账户如下，或点击修改客户账户",
    clickNotice: "点击选择业务账单",
    selectBill1: "请选择业务账单",
    selectBill2: "请选择财务账单",
    exchange: "换汇",
    writeOff: "销账",
    all: "全部",
    currencyError: "不能选择同一个货币",
    excess: "超出可用余额",
    applicant: "请款人",
  },
  buildWayBillNo: {
    kefu: "客服",
    marketing: "市场",
    sales: "销售",
    operation: "操作",
    shippingDetail: "发货详情",
    shipperCompany: "发货人公司",
    address: "地址",
    country: "国家",
    destination: "目的地详情",
    consigneeCompany: "收货人公司",
    phone: "手机号",
    postalCode: "邮政编码",
    trackNumberDetails: "单号详情",
    productName: "品名",
    customsCode: "海关编码",
    weight: "重量",
    numberBoxes: "箱数",
    boxUnit: "箱数单位",
    volume: "体积",
    value: "货值",
    currency: "货币",
    others: "其他",
    tradingPlatform: "交易平台",
    remark: "备注",
    totalData: "数据合计",
    totalWeight: "合计重量",
    totalCases: "合计箱数",
    contactError: "该公司没有联系人",
    selectUser: "请选择用户",
    selectDate: "请选择日期",
    wbNumber: "主/分运单号",
    wbNumberData: "加载主/分运单号数据",
    totalCargoQuantity: "总货物数量",
    cargoQuantity: "物品数量",
    searchCustomsCode: "搜索海关编码",
    searchCommodityCode: "搜索商品编码",
    customsCommodityCode: "海关商品编码",
  },
  antiMoneyLaundering: {
    title1: "反洗钱名单查询",
    title2: "反洗钱记录查询详情",
    search: "查询",
    antiSearch: "反洗钱查询",
    name: "名称",
    address: "地址",
    identityNum: "证件号",
    bic: "BIC 代码",
    country: "国家/地区",
    narrative: "附言",
    swift: "swift 报文",
    tshpzh: "业务编号",
    caseId: "预警编号",
    attribute: "名单属性",
    qPeople: "查询人",
    qDate: "查询日期",
    antiOption1: "正常",
    antiOption2: "制裁",
    queryResult: "查询结果",
    antiView: "预警查看",
    dialogQueryTitle: "30天内已查询过相同信息，是否需要重复查询？",
  },
  platformOrders: {
    tab1: "订单列表",
    tab2: "Manifest列表",
    orderCustomerinvoicecode: "订单号",
    wbNumber: "运单号",
    paymenttypeCode: "付款代码",
    paymentType: "付款类型",
    boxNo: "箱号",
    mawb: "主单号",
    weight: "重量",
    volume: "体积",
    totalValue: "总体积",
    totalWeight: "总重量",
    orderPiece: "件数",
    referenceNo: "参考号",
    packageNo: "包裹号",
    orderDate: "下单日期",
    createTime: "添加日期",
    expectedDeliveryDate: "预计到货日期",
    consigneeOrShipperName: "收件人/发件人名称",
    consigneeOrShipperCompanyName: "收件人/发件人公司名",
    consigneeOrShipperPhone: "收件人/发件人手机号",
    consigneeName: "收件人姓名",
    consigneeCompanyname: "收件人公司名",
    consigneeTelephone: "收件人电话",
    consigneeMobile: "收件人手机号",
    consigneeAddress: "收件人地址",
    consigneeCountry: "收件人国家",
    consigneeCity: "收件人城市",
    consigneeCountryCity: "收件国家城市",
    consigneeState: "收件人州省",
    consigneePostcode: "收件人邮编",
    consigneePassportno: "收件人护照号",
    consigneeEmail: "收件人邮箱",
    consigneeTaxno: "收件人税号",
    shipperName: "发件人姓名",
    shipperCompanyname: "发件人公司名",
    shipperTelephone: "发件人电话",
    shipperPhone: "发件人手机号",
    shipperAddress: "发件人地址",
    shipperCountry: "发件人国家",
    shipperState: "发件人州省",
    shipperCity: "发件人城市",
    shipperPostcode: "发件人邮编",
    shipperPassportno: "发件人护照号",
    shipperEmail: "发件人邮箱",
    shipperTaxnotype: "税号类型",
    shipperTaxno: "发件人税号",
    shipperTaxnocountry: "发件人税号国家",
    orderCodamount: "COD 金额",
    orderCodcurrency: "COD 币种",
    chargeableWeight: "计费重量",
    codOrNonCod: "是否 COD",
    itemDescEn: "货物描述英文",
    itemQuantity: "货物数量",
    declareValue: "申报价值",
    declareValueCurrency: "申报价值货币",
    label1: "订单信息",
    label2: "收件人信息",
    label3: "发件人信息",
    label4: "进口商信息",
    label5: "订单产品",
    customerinvoicecode: "客户的原始单号 / 参考号",
    orderReturnsign: "退回标志",
    tradeType: "贸易类型",
    orderTransactionurl: "产品销售地址",
    orderCargoamount: "订单货物金额",
    orderInsurance: "保险金额",
    cargoType: "包裹类型",
    importCode: "进口商代码",
    importName: "进口商名称",
    importCompanyname: "进口商公司名称",
    importAddress: "进口商地址",
    importTelephone: "进口商电话",
    importEmail: "进口商邮箱",
    importPostcode: "进口商邮编",
    importCountry: "进口商国家",
    importState: "进口商州省",
    importCity: "进口商城市",
    invoiceAmount: "申报总价值",
    invoiceCurrency: "申报币种",
    invoiceTitle: "英文品名",
    sku: "中文品名",
    skuCode: "配货信息",
    hsCode: "海关编码",
    invoicePcs: "件数",
    invoiceWeight: "单件重",
    invoiceVolume: "单件体积",
    volumeHeight: "高",
    volumeLength: "长",
    volumeWidth: "宽",
    volumeWeight: "实重",
    transactionUrl: "销售地址",
    invoiceunitCode: "申报单位",
    invoiceImgurl: "图片地址",
    noImage: "暂无图片",
    invoiceBrand: "品牌",
    invoiceRule: "规格",
    invoiceTaxno: "税则号",
    originCountry: "原产国",
    invoiceMaterial: "材质",
    invoicePurpose: "用途"
  },
  vehicles: {
    vin: "车辆识别码",
    plate: "车牌号",
    brand: "品牌",
    model: "型号",
    color: "颜色",
    length: "车长（米）",
    width: "车宽（米）",
    height: "车高（米）",
    vehicleType: "车辆类型",
    vehiclePhoto: "车辆照片",
    dimensions: "车辆尺寸",
    maxLoad: "最大载重（kg）",
    vehicleStatus: "车辆状态",
    vStatus1: "在用",
    vStatus2: "维修",
    vStatus3: "停用",
    vStatus4: "报废",
    addVehicle: "新建车辆",
    editVehicle: "编辑车辆",
    updateVehicleStatus: "更新车辆状态",
    sheetNotice: "请先勾选车辆",
  },
  expressEmployee: {
    addEmployeeRole: "新建员工信息",
    editEmployeeRole: "编辑员工信息",
    employeeRole: "员工角色",
    role1: "司机",
    role2: "派送员",
    role3: "仓库管理员",
    surname: "姓名",
    male: "男",
    female: "女",
    gender: "性别",
    nationality: "国籍",
    birthDate: "出生日期",
    idCardNumber: "身份证号码",
    idCardAddress: "身份证地址",
    currentAddress: "现住址",
    phoneNumber: "手机号码",
    alternatePhone: "备用电话",
    email: "电子邮箱",
    emergencyContact: "紧急联系人",
    emergencyPhone: "紧急联系电话",
    addUser: "添加用户",
    createTime: "添加日期",
    accountActivate: "账户激活",
    aStatus1: "未激活",
    aStatus2: "已激活",
    accountLock: "账户锁定",
    lStatus1: "正常",
    lStatus2: "锁定",
    createButton: "新建员工",
    lockButton: "锁定",
    unlockButton: "解锁",
    avatarPhoto: "头像照片",
  },
  cargoWarehousing: {
    returnWarehouse: "退回仓库",
    exceptionHandling: "异常处理",
    exceptionReason: "异常原因",
    deliveryExceptionReason: "派送异常原因",
    exceptionNotice: "转派提醒",
    exceptionText(val) {
      return "转派最多只支持操作3次，您还可以操作" + val + "次";
    },
    exceptionAddress: "收货地址",
    exceptionTrim: "最多只能转派3次",
    transferDeliveryCount: "转派次数",
    eState1: "转派",
    eState2: "退仓",
    tab1: "待入库",
    tab2: "已入库",
    tab3: "已出库",
    tab4: "异常货物",
    label1: "订单信息",
    label2: "收货人信息",
    label3: "司机送货信息",
    label4: "仓库信息",
    label5: "派送信息",
    label6: "货物详情信息",
    outboundBatch: "出库批次",
    warehouseEntryNumber: "入库号",
    wbNumber: "主/分运单号",
    mainWbNumber: "主运单号",
    sideWbNumber: "分运单号",
    totalNumber: "总件数",
    totalWeight: "总重量",
    totalValue: "总体积",
    isCodorder: "cod订单",
    consignee: "收货人",
    consigneePhone: "收货人电话",
    consigneeAddress: "收货人地址",
    pod: "目的地",
    headPhoto: "司机头像",
    noImage: "暂无图片",
    driver: "司机",
    driverName: "司机姓名",
    driverOrStorageName: "司机或仓库员名称",
    driverDeliveryState: "司机送货状态",
    dState1: "未送达",
    dState2: "送货中",
    dState3: "已送达",
    phoneNumber: "司机电话",
    vehicle: "车辆",
    vehiclePhoto: "车辆照片",
    licensePlate: "送货车牌号",
    color: "颜色",
    cargoReceivedPhoto: "接货图片",
    cargoArrivalPhoto: "货物送达图片",
    uploadTime: "上传时间",
    warehouse: "仓库",
    warehouseCode: "仓库代码",
    warehouseName: "仓库名称",
    warehouseAddress: "仓库地址",
    storageHeadPhoto: "仓库员头像",
    storageName: "仓库员名称",
    storagePhoneNumber: "仓库员电话",
    warehouseKeeper: "仓库管理员",
    cargoWarehousingTime: "入库时间",
    applyOutboundTime: "出库时间",
    outboundTypeLabel: "出库类型",
    outboundType1: "出仓",
    outboundType2: "转仓",
    deliverer: "派送员",
    deliveryPersonHeadPhoto: "派送员头像",
    deliveryPersonName: "派送员名称",
    deliveryPersonPhoneNumber: "派送员电话",
    deliveryTime: "派送时间",
    completionTime: "完成时间",
    goodsName: "品名",
    hsCode: "海关编码",
    orderPiece: "件数",
    weight: "重量",
    volume: "体积",
    goodsValue: "货值",
    outBoundState: "出库状态",
    obState1: "待出库",
    obState2: "派送中",
    obState3: "已完成",
    obState4: "待退回",
    applyOutbound: "申请出库",
    editOutbound: "编辑出库批次",
    viewTitle: "查看货物入库单",
    editTitle: "编辑货物入库单",
    submitNotice1: "当前操作会令取消勾选的运单号进行出库回退，是否继续？",
    submitNotice2: "当前操作会删除取消勾选的运单号，是否继续？",
    mawbNumber: "大箱件数",
    username: "操作人",
    createTime: "操作时间",
    exception1: "异常处理",
    exception2: "异常处理记录",
    postcode: "邮编",
    receivingName: "收件人姓名",
    contactPhone: "联系电话",
    country: "国家",
    city: "城市",
    receivingAddress: "收货详细地址",
  },
  onlineOrder: {
    quotationNo: "报价编号/运输产品简称",
    shippingProductName: "运输产品名称",
    warehouseSearch: "仓库名称/仓库代码",
    warehouseCode: "仓库代码",
    warehouseName: "仓库简称",
    warehouseAddress: "仓库地址",
    warehouseStatus: "仓库状态",
    warehouseContact1: "仓库联系人1",
    warehouseContact2: "仓库联系人2",
    warehousePhone: "仓库联系电话",
    warehouseEmail: "仓库联系邮件",
    warehouseTime: "仓库运营时间",
    warehouseGoods: "集货仓库",
    companyName: "公司名称",
    companyIcon: "公司图标",
    contact: "联系人",
    state: "状态",
    quoUpdateTime: "报价更新日期",
    bjNumber: "报价编号",
    username: "更新人员",
    countryName: "国家名称",
    countryFlag: "国家国旗",
    addPeople: "添加人",
    createTime: "添加日期",
    updateTime: "更新日期",
    disableOption: "已停用",
    enableOption: "已启用",
    addTitle1: "新建运费价格",
    editTitle1: "编辑运费价格",
    viewTitle1: "查看运费价格",
    addTitle2: "新建仓库信息",
    editTitle2: "编辑仓库信息",
    addTitle3: "新建报价信息",
    editTitle3: "编辑报价信息",
    addTitle4: "新建供应商报价",
    editTitle4: "编辑供应商报价",
    stepper1: "报价明细",
    stepper2: "运费价格明细",
    firstTab: "Express 运费管理",
    secondTab: "仓库管理",
    thirdTab: "Vancheen 报价管理",
    fourthTab: "境外跨境清关服务",
    attribute: "不接受的商品属性",
    liquid: "液体",
    powder: "粉末",
    paste: "膏状",
    charged: "带电",
    magnetic: "带磁性",
    unlimited: "无限制",
    arrivalCountry: "送抵国家地区",
    firstWeightPrice: "首重价格",
    continuePrice: "续重价格",
    firstEachWeight: "首重每公斤",
    firstWeight: "首重重量(KG)",
    continueWeightPrice: "续重每公斤",
    continueWeight: "续重重量(KG)",
    arriveDay: "运抵天数",
    cargoCategory: "运输服务(中文)",
    cargoCategoryEn: "运输服务(英文)",
    transportTime: "运输时长(天数)",
    cargoCategorySn: "运输服务",
    postNumber: "快递单号",
    goodsName: "货物名称",
    cargoTrackingNumber: "货物查询号",
    customerNumber: "客户编号",
    customerName: "客户名称",
    storageTime: "入库日期",
    numberPackages: "包裹数量",
    numberPackagesSn: "包裹数",
    volume: "体积",
    weight: "重量",
    weightUnit: "重量单位",
    numberBoxes: "箱数",
    numberBoxesOrder: "客户下单箱数",
    chargeableWeight: "计费重量",
    noImage: "暂无图片",
    outbound: "出境启运",
    tab1: "物流驿站平台",
    wbNumber: "运单号",
    departureDate: "启运日期",
    logisticsState: "物流状态",
    countryCode: "目的国",
    country: "目的地国家",
    goodState: "货物状态",
    state1: "运输中",
    state2: "待提货",
    state3: "待派送",
    state4: "已完成",
    deliveryMethod: "提货方式",
    takeDeliveryType1: "到仓自提",
    takeDeliveryType2: "申请派送",
    pickUpCode: "取件码",
    completionTime: "签收日期",
    orderDate: "下单日期",
    consigneeName: "收件人姓名",
    receiveCustomer: "收货人名称",
    receivePhone: "收货人电话",
    receiveAddress: "收货人地址",
    phoneNumber: "联系电话",
    receivingAddress: "收货详细地址",
    putInStorage: "订单入库",
    dialogTitle: "客户订单入库",
    remark: "中文备注",
    remarkEn: "英文备注",
    logoImg: "图标",
    cargoQuantity: "物品数量",
    goodsValue: "货值",
    isUnpack: "是否拆包",
    generateWaybill: "一键生成运单",
    generateExpress: "生成快递运单",
    conversionFactor: "体积重量系数",
    faceSheet: "查看面单",
    setPrice: "设置价格",
    viewPrice: "查看运费价格",
    discountRate: "折扣率",
    addPrice: "添加折扣",
    editPrice: "编辑折扣",
    serviceProvider: "服务商",
    productCode: "产品编码",
    dialogBillingTitle1: "请输入计费信息",
    dialogBillingTitle2: "请确认收费信息",
    dialogBillingTitle3: "请完善服务商信息",
    length: "长",
    width: "宽",
    height: "高",
    weight: "重量",
    prevStep: "上一步",
    nextStep: "下一步",
    firstWeightSn: "首重重量",
    continueWeightSn: "续重重量",
    totalFreight: "运费总额",
    declareValue: "申报价值",
    declareValueCurrency: "申报价值货币",
    deliveryZipCode: "发货人邮政编码",
    naqel_ShippingDateTime: "发货时间",
    naqel_DescriptionOfGoods: "货物描述",
    naqel_NumberOfPieces: "件数",
    iMile_PackageTotalVolume: "包裹总体积",
    iMile_PackageGrossWeight: "包裹毛重",
    iMile_PackageTotalCount: "包裹总件数",
    iMile_PackageGoodsType: "包裹货物类别",
    itemsTitle: "货物明细",
    customsCurrency: "申报货币",
    hsCode: "海关编码",
    batchPrice: "批量添加优惠",
    discountType: "优惠类型",
    discountType1: "百分比",
    discountType2: "固定金额",
    discountRate: "优惠率",
    discountAmount: "优惠金额",
    scanTitle1: "扫描快递单号",
    scanTitle2: "扫描运单号",
    setPointRule: "积分规则",
    addRule: "添加规则",
    deleteRule: "删除规则",
    viewRuleHistory: "查看历史记录",
    pointsObtainConditions: "积分获取条件",
    pointsIncome: "积分收入",
    reducedPointsIncome: "抵扣后的积分收入",
    ruleDate: "废弃日期",
    supplier: "供应商",
    area: "地区",
    bcType: "业务类别",
    awWay: "接入途径",
    updateTime: "更新日期",
    companyNameKeyword: "供应商名称关键字",
    serviceState: "报价状态",
    serviceState1: "启用",
    serviceState2: "停用",
    vatRate: "VAT税率",
    minVatAmount: "VAT最低收费金额",
    minVatCurrency: "VAT最低收费货币",
    customsDutyRate: "关税税率",
    minCustomsDutyAmount: "关税最低收费金额",
    minCustomsDutyCurrency: "关税最低收费货币",
    highValueFee: "高货值申报费",
    highValueFeeCurrency: "高货值申报费货币",
    productTaxRateList: "产品税率列表",
    productCategory: "产品类别",
    taxFeebearingParty: "税费承担方",
    shipperSn: "发货人",
    consigneeSn: "收货人",
    totalQty: "总数量",
    unpackTitle: "客户订单拆包",
    unpackButton: "拆包",
    unpackQty: "拆包数量",
    packageSn: "包裹",
    taxTotal: "税费",
    taxStep: "税费计算步骤",
    isTaxFeebearingPartyInconsistent: "注意：您选择的订单中，税费支付方不统一。若继续以当前组合提交，系统将默认所有税费均由发货人承担。如需变更，请调整订单组合。",
    dialogSheetTitle: "面单打印选项",
    isPrintVtrackLabel1: "打印渠道商标签",
    isPrintVtrackLabel2: "打印Vtrack标签",
    totalWeight: "货物总重量",
    storageOverdueDays: "仓储超期天数",
    shipmentCount: "主提单数(份)",
    billCount: "分提单数(份)",
    conatiner20: "20柜型",
    conatiner40: "40柜型",
    conatiner40HQ: "40HQ柜型",
    cifGoodsValue: "CIF 货值 (USD)",
    piecesNumber: "件数",
    supplierName: "供应商名称",
    notes: "操作注意事项",
    chargeItems: "收费项目",
    section: "分段",
    billName: "账单款项",
    chargingUnit: "收费单位",
    minChargingPrice: "最低收费价格",
    unitPrice: "单价",
    isMandatoryItem: "是否必收项",
    mandatory1: "必收",
    mandatory2: "发时收取",
    mandatory3: "按单实报实销",
    costPrice: "成本价格",
    profitPrice: "利润价格",
    salesPrice: "销售价格",
    calculatePrice: "计算费用",
    calculateDetail: "计算明细",
    chargingCurrency: "收费货币",
    oCurrency: "原币",
    dCurrnecy: "显示货币",
    isCustomsInspection: "是否海关查验",
    isChargeUponDelivery: "是否包含发时收取",
    isCostReimbursement: "是否包含按单实报实销",
    totalCost: "总成本",
    totalProfitPrice: "总利润调整额",
    totalSalesPrice: "建议总销售价",
    recordTitle: "沟通记录",
    communicationExplanation: "沟通说明",
    viewRecord: "查看记录",
    communicationTitle: "沟通记录详情",
    voucherFiles: "凭证文件",
    fileList: "文件列表",
    file: "文件",
    viewFile: "查看文件",
    recordUserName: "更新人",
    recordCreateTime: "更新时间",
    divider1: "收费信息",
    divider2: "货物信息",
    divider3: "货币信息",
    divider4: "报价总计",
    divider5: "报价备注",
    divider6: "备注记录",
  },
  calculator: {
    input: "请输入",
    select: "请选择",
    length: "长(cm)",
    width: "宽(cm)",
    height: "高(cm)",
    weight: "重量(kg)",
    search: "查询",
    col1: "运输服务",
    col2: "首重重量",
    col3: "首重价格",
    col4: "续重重量",
    col5: "续重价格",
    col6: "运输时长",
    day: "天",
    empty: "暂无数据",
    remark: "备注",
    orderBy1: "价格升序",
    orderBy2: "价格倒序"
  },
  businessEntity: {
    companyName: "公司名称",
    companyLogo: "公司Logo图片",
    officialSeal: "公章图片",
    englishName: "英文名称",
    foreignLanguageName: "外语本语名称",
    establishmentDate: "成立日期",
    legalPerson: "法人",
    region: "注册地区",
    address: "注册地址",
    registeredCapital: "注册资本",
    remark: "备注",
    shareHolder: "股东列表",
    fullname: "姓名",
    equityStake: "股权比例",
    status: "状态",
    option1: "正常",
    option2: "停用",
    noImage: "暂无图片",
    addButton: "新建营业主体",
    bankAccountList: "收款账户列表",
    bankAccount: "收款账户",
    accountNickName: "账户名称",
    accountName: "账户名",
  },
  goodsInventory: {
    productName: "商品名称",
    productNameEn: "商品英文名称",
    domesticPlaceOrigin: "境内货源地",
    productImages: "商品图片",
    productDescription: "商品描述",
    productQuotation: "商品报价",
    customsDeclaration: "海关申报信息",
    customsDeclarationName: "商品报关名称",
    brand: "品牌",
    model: "型号",
    packageNumber: "单件包装数量",
    hsCode: "海关编码",
    specification: "规格",
    unitName: "报价单位",
    customerNumber: "客户编号",
    customerName: "公司名称/供应商名称",
    sixMonthAvgPrice: "6个月采购商均价(不含税)",
    minPrice: "最低价格(不含税)",
    minPriceCustomerNumber: "最低价格供应商编号",
    minPriceCompanyName: "最低价格供应商公司名",
    minPriceCustomerPhone: "最低价格供应商电话",
    priceValidityPeriod: "价格有效期",
    priceStartEffectiveDate: "价格开始有效期",
    priceExpirationDate: "价格结束有效期",
    noImage: "暂无图片",
    orderBy1: "创建时间倒序",
    orderBy2: "采购商均价升序",
    orderBy3: "采购商均价倒序",
    createProduct: "新建商品",
    editProduct: "编辑商品",
    grossWeight: "单件毛重(kg)",
    volume: "单件体积(m3)",
    countryOrigin: "原产地/国",
    startDate: "开始日期",
    to: "至",
    endDate: "结束日期",
    brandLicensing: "品牌授权",
    brandLicensingDate: "品牌授权有效期",
    sort: "排序",
    qOrderBy1: "报价日期倒序",
    qOrderBy2: "报价日期升序",
    qOrderBy3: "税前采购价格倒序",
    qOrderBy4: "税前采购价格升序",
    qOrderBy5: "税后采购价格倒序",
    qOrderBy6: "税后采购价格升序",
    qNumber: "报价单号",
    supplier: "供应商",
    supplierNumber: "供应商编号",
    supplierName: "供应商简称",
    preTaxPurchasePrice: "税前采购价格",
    invoicingTaxRate: "开票税费费率",
    invoiceType: "发票类别",
    invoiceType1: "增值税专票",
    invoiceType2: "增值税普通发票",
    afterTaxPurchasePrice: "税后采购价格",
    invoiceIncludingTaxRate: "发票含税率",
    productTaxAmount: "产品税额",
    productState: "商品状态",
    normal: "正常",
    disable: "停用",
    quoteDate: "报价日期",
    createQuotation: "新建报价",
    minimumOrderQuantity: "起订量",
    procurementConsiderations: "采购注意事项",
  },
  tradeOrder: {
    jobNumber: "工作单号",
    orderNumber: "订单编号",
    customerNumber: "客户编号",
    customerCompanyName: "客户公司名称",
    tradeTerms: "贸易条款",
    deliveryDestination: "交付目的地",
    totalReceive: "应收总额",
    receivable: "待收余额",
    taxRefundTotalAmount: "可退税总额",
    procurementTotalAmount: "应付总额",
    paymentBalance: "待付余额",
    financialAccountNo: "财务记账流水编号",
    companyNameSn: "企业简称",
    invoiceNo: "账单号",
    totalPayable: "应付总额",
    totalPayableBalance: "应付余额",
    totalReceive: "应收总额",
    totalReceiveBalance: "应收余额",
    viewCost: "查看成本",
    deleteCost: "删除成本",
    viewSell: "查看卖价",
    deleteSell: "删除卖价",
    subTotal: "应收小计",
    rate: "汇率",
    totalAmount: "成本合计",
    receTotalAmount: "应收合计",
    profitTotalAmount: "利润合计",
    notice: "提示",
    deleteCheck1: "确认删除此成本?",
    deleteCheck2: "确认删除此卖价?",
    nuType1: "收款",
    nuType2: "付款",
    sheet1: "收款账单",
    sheet2: "供应商成本",
    reconciliation: "客资对账",
    printTitle: "贸易订单打印",
    printOption1: "采购商品清单",
    printOption2: "销售产品清单",
    createOrder: "贸易订单生成",
    viewDraft: "查看草稿",
    deleteDraft: "删除草稿",
    saveDraft: "保存草稿",
    draftName: "草稿名称",
    productNameSn: "品名",
    brand: "品牌",
    model: "型号",
    specifications: "规格",
    searchProduct: "查询产品",
    noImage: "暂无图片",
    productName: "商品名称",
    productNameEn: "商品英文名称",
    customsDeclarationName: "商品报关名称",
    customsDeclarationInfo: "海关申报信息",
    domesticPlaceOrigin: "境内货源地",
    unitName: "报价单位",
    hsCode: "海关编码",
    supplier: "供应商",
    quotation: "采购报价",
    entity: "营业主体",
    quantity: "采购数量",
    preTaxPurchasePrice: "税前采购价格",
    invoicingTaxRate: "开票税费费率",
    afterTaxPurchasePrice: "税后采购价格",
    minimumOrderQuantity: "起订量",
    procurementConsiderations: "采购注意事项",
    collapse1: "采购订单",
    collapse2: "销售订单",
    subTitle1: "采购商品清单",
    subTitle2: "销售产品清单",
    button1: "添加采购名录",
    button2: "同步商品",
    button3: "计入应收",
    total1: "采购数量合计",
    total2: "采购总额(CNY)",
    total3: "订单销售总价",
    total4: "订单销售总价(CNY)",
    total5: "手续费总额",
    total6: "手续费总额(CNY)",
    total7: "订单预计总应收(CNY)",
    total8: "预计订单总利润(CNY)",
    total9: "利润率",
    total10: "预计退税总额",
    subtotal: "小计",
    refundSubtotal: "退税小计",
    customerName: "客户名称",
    accountNo: "银行账户",
    bankAccount: "收款账户",
    contact: "联系人",
    phoneNumber: "联系电话",
    deliveryCountry: "交付国家",
    deliveryDestination: "交付目的地",
    address: "地址",
    tradeTerms: "贸易条款",
    procurementFeeRate: "采购手续费率",
    tradeCurrency: "交易货币",
    exchangeRate: "交易汇率",
    fobCurrency: "FOB本地费用货币",
    fobCost: "FOB本地费用",
    jobNumber: "工作单号",
    orderNumber: "订单编号",
    checkbox1: "是否申报出口退税",
    salesUnitPrice: "销售价格",
    deleteSuccess: "删除成功",
    synError: "请先添加采购名录",
    quantityError: "采购数量不能少于起订量",
    updateSuccess: "采购商品已更新",
    addSuccess: "添加成功",
    pickerError1: "该客户没有收款账户",
    pickerError2: "该营业主体没有收款账户",
    pickerError3: "该产品没有供应商",
    pickerError4: "该产品没有报价信息"
  },
  procurementQuotationSettings: {
    createUnit: "新建报价单位",
    editUnit: "编辑报价单位",
    unitNameCN: "单位名称中文",
    unitNameEN: "单位名称英文",
    unitNameAR: "单位名称阿拉伯文",
  },
  freightInquiry: {
    tableTitle: "收费标准",
    placeHolder: "请选择国家",
    divider: "续重",
    col1: "运输服务",
    col2: "首重重量",
    col3: "首重价格",
    col4: "续重重量",
    col5: "续重价格",
    col6: "运输时长",
    day: "天",
    warehouseContact: "仓库联系人",
    warehousePhone: "仓库联系电话",
    warehouseAddress: "仓库地址",
    copy: "一键复制",
    empty: "暂无数据",
    none: "无",
    remark: "备注",
    supplier: "供应商",
    area: "地区",
    bcName: "业务类别",
    updateTime: "更新日期",
    companyNameKeyword: "供应商名称关键字",
    countryName: "国家名称",
    cargoCategory: "运输服务",
    freightPriceCalculator: "运费计算器",
    tab1: "快递查询",
    tab2: "其他服务",
    quotationDetail: "报价详情",
    customerNumber: "客户编号",
    customerCompanyName: "客户公司名",
    awWay: "接入途径",
    dCurrnecy: "显示货币",
    dCurrnecySymbol: "显示货币符号",
    weight: "重量",
    volume: "体积",
    shipmentCount: "主提单数",
    billCount: "分提单数",
    cifGoodsValue: "CIF货值",
    piecesNumber: "件数",
    storageOverdueDays: "仓储超期天数",
    conatiner20: "20柜型",
    conatiner40: "40柜型",
    conatiner40HQ: "40HQ柜型",
    isCustomsInspection: "是否海关查验",
    isMandatoryItem: "是否必收项",
    mandatory1: "必收",
    mandatory2: "发时收取",
    mandatory3: "按单实报实销",
    notes: "操作注意事项",
    feeSchedule: "收费标准",
    itemName: "账单款项名称",
    unitName: "收费单位名称",
    costPrice: "成本价格",
    totalCostPrice: "总成本价格",
  },
  address: {
    addAddress: "新建收货地址",
    editAddress: "编辑收货地址",
    postcode: "邮编",
    receivingName: "收件人姓名",
    phoneNumber: "联系电话",
    receivingAddress: "收货详细地址",
    isDefault: "是否默认收货地址",
    selectAddress: "请选择地址",
    chinese1: "你的中国专属收货地址",
    chinese2: "仓库简称",
    chinese3: "联系人",
    chinese4: "联系电话",
    chinese5: "地址",
    copy: "点击复制"
  },
  myWallet: {
    accountBalance: "账户余额",
    processAccountBalance: "扣费中金额",
    fundType1: "充值",
    fundType2: "消费",
    fundType3: "换汇入账",
    fundType4: "换汇支出",
    balance: "余额",
    fundTypeStr: "资金类型",
    tradeNumber: "交易号",
    rechargeAmount: "充值金额",
    rechargeTime: "充值时间",
    paymentMethod: "支付方式",
    payment1: "支付宝",
    payment2: "微信",
    payment4: "线下支付",
    orderState: "订单状态",
    pState1: "待支付",
    pState2: "已支付",
    pState3: "已取消",
    entryState: "入账状态",
    eState1: "待审核",
    eState2: "已入账",
    eState3: "已取消",
    tab1: "充值记录",
    tab2: "账户流水",
    listButton: "付款 / 查看",
    rechangeButton: "立即充值",
    payAmount: "支付金额",
    payVoucher: "支付凭证",
    tradeCurrency: "交易货币",
    accountName: "账户名",
    accountNumber: "账号",
    tips1: "注意事项",
    tips2: "无论选择哪种支付方式，充值成功后资金都不会立即到账，需要等待审核员进行资金核查，通常会在1~2个工作日内审核通过，请您耐心等待。资金如果长时间未到账，请直接联系管理员进行咨询确认。",
    cancelPayment: "取消支付",
    payNow: "立即支付"
  },
  paybillList: {
    totalAmount: "应付合计",
    approvedAmount: "已付合计",
    billState1: "待结账",
    billState2: "已结账",
    billState3: "待审核",
    subTotalAmount: "应付小计",
    subApprovedAmount: "已付小计",
    chargeMoney: "收费款项",
    payableBills: "应付账单",
    onPay: "立即支付",
  },
  order: {
    payType: "支付方式",
    onPay: "立即支付",
    paymentOption1: "支付宝",
    paymentOption2: "微信",
  },
  orderManagement: {
    search1: "订单 / 快递单 / 运单号",
    search2: "收 / 发货人",
    orderNo: "订单号",
    expressNo: "快递号",
    wbNumber: "运单号",
    serviceProvider: "服务商",
    none: "无",
    cargoCategory: "运输服务",
    shipper: "发货人",
    shipperName: "发货人名称 / 电话",
    shipperContact: "发货联系人",
    shipperPhoneNumber: "发货电话号码",
    consignee: "收货人",
    consigneeName: "收货人名称 / 电话",
    consigneeContact: "收货联系人",
    declareValue: "申报价值",
    declareValueCurrency: "申报价值货币",
    itemsTitle: "货物明细",
    weight: "重量",
    volume: "体积",
    boxNumber: "箱数",
    orderDate: "下单日期",
    addButton: "新建订单",
    skuName: "品名",
    skuQty: "数量",
    hsCode: "海关编码",
    companyName: "公司名称",
    contactName: "联系人姓名",
    phoneNumber: "电话号码",
    email: "电子邮箱",
    zipCode: "邮政编码",
    detailAddress: "详细地址",
    naqel_ShippingDateTime: "发货时间",
    naqel_DescriptionOfGoods: "货物描述",
    naqel_NumberOfPieces: "件数",
    iMile_PackageTotalVolume: "包裹总体积",
    iMile_PackageGrossWeight: "包裹毛重",
    iMile_PackageTotalCount: "包裹总件数",
    iMile_PackageGoodsType: "包裹货物类别",
    itemsTotal: "数据合计",
    totalWeight: "总重量",
    totalValue: "总体积",
    totalBoxNumber: "总箱数",
    totalQuantity: "总货物数量",
    orderDetail: "订单详情",
    createOrder: "新建订单",
    others: "其他",
    declareTitle: "申报详情",
    productCategory: "产品类别",
    taxFeebearingParty: "税费承担方",
  },
  exportGoodsStatistics: {
    receiveCountry: "收货国家",
    receiveCity: "目的地城市",
    transportType: "运输方式",
    goodsName: "品名",
    hsCode: "海关编码",
  }
};
export default messages;
